var _path, _path2, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMutualfunds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-159"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-159",
    cx: 250,
    cy: 363.89,
    rx: 225.48,
    ry: 130.18,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sparkles--inject-159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shine--inject-159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shine--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.72,187.07a.23.23,0,0,1-.24-.22l-.6-6.63a1.18,1.18,0,0,0-1-1.07l-5.2-.57a.25.25,0,0,1-.22-.24.26.26,0,0,1,.22-.24l5.2-.57a1.18,1.18,0,0,0,1-1.07l.6-6.63a.23.23,0,0,1,.24-.22.24.24,0,0,1,.24.22l.6,6.63a1.16,1.16,0,0,0,1,1.07l5.2.57a.25.25,0,0,1,.21.24.24.24,0,0,1-.21.24l-5.2.57a1.16,1.16,0,0,0-1,1.07l-.6,6.63A.24.24,0,0,1,29.72,187.07Zm-4.87-8.73,3,.34a1.65,1.65,0,0,1,1.47,1.49l.36,4,.36-4a1.65,1.65,0,0,1,1.47-1.49l3-.34-3-.34a1.65,1.65,0,0,1-1.47-1.49l-.36-4-.36,4h0A1.65,1.65,0,0,1,27.89,178Zm4.27-1.85h0Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.28,170.76a.24.24,0,0,1-.24-.22L40.63,166a.71.71,0,0,0-.64-.65L36.45,165a.25.25,0,0,1-.21-.24.23.23,0,0,1,.21-.24l3.54-.39a.73.73,0,0,0,.64-.66l.41-4.51a.23.23,0,0,1,.24-.22.24.24,0,0,1,.24.22l.4,4.51a.73.73,0,0,0,.65.66l3.54.39a.23.23,0,0,1,.21.24.25.25,0,0,1-.21.24l-3.54.39a.72.72,0,0,0-.65.65l-.4,4.52A.25.25,0,0,1,41.28,170.76Zm-2.62-6,1.38.15A1.2,1.2,0,0,1,41.11,166l.17,1.87.17-1.87a1.2,1.2,0,0,1,1.06-1.09l1.39-.15-1.39-.16a1.2,1.2,0,0,1-1.06-1.08l-.17-1.88-.17,1.88h0A1.2,1.2,0,0,1,40,164.58Zm2.21-1.27h0Z",
    style: {
      fill: "#76ABAE"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shine--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.65,57.28a.2.2,0,0,1-.2-.18L224,51.62a1,1,0,0,0-.86-.88l-4.29-.47a.2.2,0,0,1-.18-.2.19.19,0,0,1,.18-.19l4.29-.48a1,1,0,0,0,.86-.87l.49-5.48a.2.2,0,0,1,.2-.18.19.19,0,0,1,.19.18l.5,5.48h0a1,1,0,0,0,.86.87l4.29.48a.19.19,0,0,1,.18.19.2.2,0,0,1-.18.2l-4.29.47a1,1,0,0,0-.86.88l-.5,5.48A.19.19,0,0,1,224.65,57.28Zm-4-7.21,2.51.28a1.37,1.37,0,0,1,1.21,1.24l.3,3.29.29-3.29a1.37,1.37,0,0,1,1.21-1.24l2.52-.28-2.52-.27a1.38,1.38,0,0,1-1.21-1.24l-.29-3.29-.3,3.29a1.38,1.38,0,0,1-1.21,1.24Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.21,63.26a.15.15,0,0,1-.16-.15l-.28-3a.5.5,0,0,0-.43-.45L214,59.36a.16.16,0,0,1,0-.32l2.39-.27a.48.48,0,0,0,.43-.44l.28-3a.15.15,0,0,1,.16-.15h0a.16.16,0,0,1,.16.15l.27,3a.48.48,0,0,0,.44.44l2.38.27a.16.16,0,0,1,0,.32l-2.38.26a.5.5,0,0,0-.44.45l-.27,3A.16.16,0,0,1,217.21,63.26Zm-1.77-4.06.93.1a.81.81,0,0,1,.72.74l.12,1.26.11-1.26a.82.82,0,0,1,.72-.74l.93-.1-.93-.1a.82.82,0,0,1-.72-.74h0l-.11-1.26-.12,1.26a.81.81,0,0,1-.72.74Z",
    style: {
      fill: "#76ABAE"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shine--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.81,234.63a.2.2,0,0,1-.2-.18l-.49-5.48a1,1,0,0,0-.86-.87l-4.29-.48a.19.19,0,0,1-.18-.19.2.2,0,0,1,.18-.2l4.29-.48a1,1,0,0,0,.86-.87l.49-5.48a.2.2,0,0,1,.2-.18.19.19,0,0,1,.19.18l.5,5.48h0a1,1,0,0,0,.86.87l4.29.48a.19.19,0,0,1,.17.2.19.19,0,0,1-.17.19l-4.29.48a1,1,0,0,0-.86.87l-.5,5.48A.19.19,0,0,1,467.81,234.63Zm-4-7.2,2.51.27a1.37,1.37,0,0,1,1.21,1.24l.3,3.29.29-3.29a1.37,1.37,0,0,1,1.21-1.24l2.52-.27-2.52-.28a1.37,1.37,0,0,1-1.21-1.24l-.29-3.29-.3,3.29a1.37,1.37,0,0,1-1.21,1.24Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478.93,239.77a.16.16,0,0,1-.16-.15l-.27-3a.48.48,0,0,0-.43-.44l-2.39-.27a.15.15,0,0,1-.14-.16.16.16,0,0,1,.14-.16l2.39-.26a.49.49,0,0,0,.43-.44l.27-3a.17.17,0,0,1,.16-.15h0a.17.17,0,0,1,.17.15l.27,3a.49.49,0,0,0,.43.44l2.39.26a.16.16,0,0,1,.14.16.15.15,0,0,1-.14.16l-2.39.27a.48.48,0,0,0-.43.44l-.27,3A.16.16,0,0,1,478.93,239.77Zm-1.76-4.06.93.11a.81.81,0,0,1,.72.73l.11,1.26.12-1.26a.81.81,0,0,1,.72-.73l.93-.11-.93-.1a.81.81,0,0,1-.72-.73h0l-.12-1.26-.11,1.26a.81.81,0,0,1-.72.73Z",
    style: {
      fill: "#76ABAE"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shine--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M468.28,154.8a.2.2,0,0,1-.2-.18l-.49-5.48a1,1,0,0,0-.86-.88l-4.29-.47a.2.2,0,0,1-.18-.2.19.19,0,0,1,.18-.19l4.29-.48a1,1,0,0,0,.86-.87l.49-5.48a.2.2,0,0,1,.2-.18.19.19,0,0,1,.19.18l.5,5.48h0a1,1,0,0,0,.86.87l4.29.48a.19.19,0,0,1,.18.19.2.2,0,0,1-.18.2l-4.29.47a1,1,0,0,0-.86.88l-.5,5.48A.19.19,0,0,1,468.28,154.8Zm-4-7.21,2.51.28a1.37,1.37,0,0,1,1.21,1.24l.3,3.29.29-3.29a1.37,1.37,0,0,1,1.21-1.24l2.52-.28-2.52-.27a1.38,1.38,0,0,1-1.21-1.24l-.29-3.29-.3,3.29a1.38,1.38,0,0,1-1.21,1.24Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.6,49.91a.12.12,0,0,1-.13-.12l-.34-3.7a.64.64,0,0,0-.58-.59l-2.89-.32a.13.13,0,0,1-.12-.13.14.14,0,0,1,.12-.14l2.89-.32a.64.64,0,0,0,.58-.59l.34-3.69a.13.13,0,0,1,.26,0l.33,3.69h0a.66.66,0,0,0,.59.59l2.89.32a.14.14,0,0,1,.12.14.13.13,0,0,1-.12.13l-2.89.32a.66.66,0,0,0-.59.59l-.33,3.7A.12.12,0,0,1,451.6,49.91Zm-2.71-4.86,1.69.18a.93.93,0,0,1,.82.84l.2,2.22.2-2.22a.93.93,0,0,1,.82-.84l1.69-.18-1.69-.19a.93.93,0,0,1-.82-.83l-.2-2.22L451.4,44a.93.93,0,0,1-.82.83Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476,136.85a.15.15,0,0,1-.16-.14l-.28-3.05a.48.48,0,0,0-.43-.44L472.7,133a.16.16,0,0,1-.14-.17.16.16,0,0,1,.14-.16l2.39-.26a.48.48,0,0,0,.43-.44l.28-3.05a.15.15,0,0,1,.16-.14h0a.16.16,0,0,1,.16.14l.27,3.05a.49.49,0,0,0,.44.44l2.38.26a.16.16,0,0,1,.15.16.16.16,0,0,1-.15.17l-2.38.26a.49.49,0,0,0-.44.44l-.27,3.05A.16.16,0,0,1,476,136.85Zm-1.77-4.06.94.11a.8.8,0,0,1,.71.73l.12,1.26.11-1.26a.82.82,0,0,1,.72-.73l.94-.11-.94-.1a.82.82,0,0,1-.72-.73h0L476,130.7l-.12,1.26a.8.8,0,0,1-.71.73Z",
    style: {
      fill: "#76ABAE"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shine--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.89,86.07a.14.14,0,0,1-.13-.12l-.33-3.69a.67.67,0,0,0-.58-.6L22,81.34a.13.13,0,0,1-.12-.13.14.14,0,0,1,.12-.13l2.9-.32a.66.66,0,0,0,.58-.59l.33-3.7a.14.14,0,0,1,.13-.12.14.14,0,0,1,.14.12l.33,3.7h0a.66.66,0,0,0,.58.59l2.9.32a.13.13,0,0,1,.11.13.12.12,0,0,1-.11.13l-2.9.32a.67.67,0,0,0-.58.6L26,86A.14.14,0,0,1,25.89,86.07Zm-2.71-4.86,1.7.19a.93.93,0,0,1,.81.83l.2,2.22.2-2.22a.94.94,0,0,1,.82-.83l1.7-.19L26.91,81a.92.92,0,0,1-.82-.83L25.89,78l-.2,2.22a.91.91,0,0,1-.81.83Z",
    style: {
      fill: "#76ABAE"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shine--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.9,65.77a.2.2,0,0,1-.2-.18l-.52-5.76a1,1,0,0,0-.91-.93l-4.51-.49a.22.22,0,0,1-.18-.21.21.21,0,0,1,.18-.21l4.51-.5a1,1,0,0,0,.91-.92l.52-5.76a.21.21,0,0,1,.2-.19.21.21,0,0,1,.21.19l.52,5.76a1,1,0,0,0,.91.92l4.51.5a.21.21,0,0,1,.18.21.22.22,0,0,1-.18.21l-4.51.49a1,1,0,0,0-.91.93l-.52,5.76A.21.21,0,0,1,110.9,65.77Zm-4.22-7.57,2.64.29a1.44,1.44,0,0,1,1.27,1.3l.31,3.46.32-3.46a1.44,1.44,0,0,1,1.27-1.3l2.64-.29-2.64-.29a1.44,1.44,0,0,1-1.27-1.3h0l-.32-3.46-.31,3.46a1.44,1.44,0,0,1-1.27,1.3Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.55,78.93a.21.21,0,0,1-.21-.19L94,74.82a.63.63,0,0,0-.56-.57l-3.07-.34a.21.21,0,0,1-.18-.21.2.2,0,0,1,.18-.2l3.07-.34a.63.63,0,0,0,.56-.57l.35-3.92a.21.21,0,0,1,.42,0l.35,3.92h0a.63.63,0,0,0,.56.57l3.07.34a.2.2,0,0,1,.18.2.2.2,0,0,1-.18.21l-3.07.34a.63.63,0,0,0-.56.57l-.35,3.92A.21.21,0,0,1,94.55,78.93ZM92.28,73.7l1.2.14a1,1,0,0,1,.92.94l.15,1.63.15-1.63a1,1,0,0,1,.92-.94l1.2-.14-1.2-.13a1,1,0,0,1-.92-.94L94.55,71l-.15,1.63a1,1,0,0,1-.92.94Z",
    style: {
      fill: "#76ABAE"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.68,84.53a.21.21,0,0,1-.2-.19l-.36-3.92a.63.63,0,0,0-.55-.57l-3.08-.34a.2.2,0,0,1-.18-.2.21.21,0,0,1,.18-.21l3.08-.34a.62.62,0,0,0,.55-.57l.36-3.92a.21.21,0,0,1,.2-.19.21.21,0,0,1,.21.19l.36,3.92h0a.62.62,0,0,0,.55.57l3.07.34a.21.21,0,0,1,.19.21.21.21,0,0,1-.19.2l-3.07.34a.63.63,0,0,0-.55.57l-.36,3.92A.21.21,0,0,1,120.68,84.53Zm-2.27-5.22,1.2.13a1.05,1.05,0,0,1,.93.94l.14,1.63.15-1.63a1,1,0,0,1,.93-.94l1.2-.13-1.2-.14a1,1,0,0,1-.93-.94l-.15-1.62-.14,1.62a1.05,1.05,0,0,1-.93.94Z",
    style: {
      fill: "#76ABAE"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shine--inject-159",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.83,138.15a.2.2,0,0,1-.2-.18l-.35-3.84a.61.61,0,0,0-.54-.56l-3-.33a.2.2,0,0,1-.18-.2.21.21,0,0,1,.18-.21l3-.33a.6.6,0,0,0,.54-.56l.35-3.83a.21.21,0,0,1,.2-.19.2.2,0,0,1,.2.19l.35,3.84a.62.62,0,0,0,.55.55l3,.33a.21.21,0,0,1,.18.21.2.2,0,0,1-.18.2l-3,.33a.63.63,0,0,0-.55.56L281,138A.2.2,0,0,1,280.83,138.15ZM278.6,133l1.18.13a1,1,0,0,1,.91.92l.14,1.59.14-1.59a1,1,0,0,1,.91-.92l1.18-.13-1.18-.13A1,1,0,0,1,281,132h0l-.14-1.59-.14,1.59a1,1,0,0,1-.91.93Z",
    style: {
      fill: "#76ABAE"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shine--inject-159",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.48,148.67a.3.3,0,0,1-.3-.27l-.52-5.77a.92.92,0,0,0-.82-.83l-4.51-.5a.31.31,0,0,1,0-.61l4.51-.5a.93.93,0,0,0,.82-.84l.52-5.76a.31.31,0,0,1,.61,0l.52,5.77a.93.93,0,0,0,.82.83l4.51.5a.31.31,0,0,1,0,.61l-4.51.5a.92.92,0,0,0-.82.83l-.52,5.77A.31.31,0,0,1,293.48,148.67ZM290.14,141l1.77.2a1.54,1.54,0,0,1,1.36,1.39l.21,2.38.22-2.38a1.54,1.54,0,0,1,1.36-1.39l1.77-.2-1.77-.19a1.54,1.54,0,0,1-1.36-1.39h0l-.22-2.39-.21,2.39a1.54,1.54,0,0,1-1.36,1.39Z",
    style: {
      fill: "#76ABAE"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shine--inject-159",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.16,244.87a.25.25,0,0,1-.25-.23l-.42-4.7a.77.77,0,0,0-.67-.68l-3.68-.4a.26.26,0,0,1-.23-.25.25.25,0,0,1,.23-.25l3.68-.41a.76.76,0,0,0,.67-.68l.42-4.7a.25.25,0,0,1,.5,0l.42,4.7a.75.75,0,0,0,.67.68l3.68.41a.24.24,0,0,1,.22.25.25.25,0,0,1-.22.25l-3.68.4a.76.76,0,0,0-.67.69l-.42,4.69A.25.25,0,0,1,78.16,244.87Zm-2.73-6.26,1.44.16A1.25,1.25,0,0,1,78,239.9l.18,1.95.17-1.95a1.26,1.26,0,0,1,1.11-1.13l1.45-.16-1.45-.16a1.27,1.27,0,0,1-1.11-1.13h0l-.17-1.95L78,237.32a1.26,1.26,0,0,1-1.11,1.13Z",
    style: {
      fill: "#76ABAE"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--banknotes-2--inject-159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bill--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.91,184.86c-12.67-4.72-13.15-14.46-25.82-19.17l-14.75,6.38c12.67,4.72,13.15,14.46,25.82,19.18Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.14,172.09c11.43,4.79,12.33,13.68,23.77,18.46l13.2-5.71c-11.43-4.78-12.33-13.68-23.77-18.46Zm.87,0,12.43-5.38c10.86,4.79,11.94,13.3,22.79,18.09l-12.42,5.38C278,185.41,276.87,176.9,266,172.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.76,183.05a7.13,7.13,0,0,1-4.27-2.29h0a4.06,4.06,0,0,1-1-3.8,4.27,4.27,0,0,1,2.48-2.64c3-1.24,7.1-.22,8.8,1.85a4.06,4.06,0,0,1,1,3.8,4.44,4.44,0,0,1-2.49,2.64A8.55,8.55,0,0,1,282.76,183.05Zm1.66-8.91a8.39,8.39,0,0,0-4.39.43,4.18,4.18,0,0,0-2.28,2.46,3.77,3.77,0,0,0,.92,3.52h0c1.65,2,5.67,3,8.55,1.81a4.41,4.41,0,0,0,2.37-2.65,3.75,3.75,0,0,0-1-3.32A7,7,0,0,0,284.42,174.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.11,181.56a6,6,0,0,1-3.31-1.8,3,3,0,0,1-.73-2.45,2.69,2.69,0,0,1,1.61-1.62,6.32,6.32,0,0,1,3.46-.32,6.24,6.24,0,0,1,3.31,1.8,3,3,0,0,1,.73,2.46,2.65,2.65,0,0,1-1.61,1.61A6,6,0,0,1,283.11,181.56Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.52,187.87a2.62,2.62,0,0,1,2,.1c.28.14.46.22.7.32l6.57-2.82a.94.94,0,0,1-.52-.74.87.87,0,0,1,.49-.83,28.1,28.1,0,0,1-5.31-4.34c0,.16-.06.33-.1.5a6.3,6.3,0,0,1-3.73,3.75,10.69,10.69,0,0,1-5.37.76,26.62,26.62,0,0,0,4.71,3.54Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.46,186.18a2.78,2.78,0,0,1-1.31-.42,1,1,0,0,1-.51-.86.88.88,0,0,1,.58-.66,2.74,2.74,0,0,1,2.39.32,1.1,1.1,0,0,1,.57.83.75.75,0,0,1-.53.64A2.5,2.5,0,0,1,290.46,186.18Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.83,177.4a7,7,0,0,1,.15-.85c.35-1.39,1.63-2.61,3.6-3.44a10.68,10.68,0,0,1,5.4-.71,26.48,26.48,0,0,0-4.67-3.5l-.55.23a2.62,2.62,0,0,1-2-.1c-.28-.13-.45-.22-.7-.32l-6.55,2.79a1,1,0,0,1,.51.74.87.87,0,0,1-.49.83A28.41,28.41,0,0,1,275.83,177.4Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.83,173a2.72,2.72,0,0,1-1.24-.45h0a1.06,1.06,0,0,1-.55-.84.72.72,0,0,1,.52-.64,2.94,2.94,0,0,1,2.49.28.94.94,0,0,1,.5.86.91.91,0,0,1-.59.67A2.21,2.21,0,0,1,276.83,173Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bill--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.78,34.9c10.75,8.2,19.24,3.4,30,11.61q1.25,7.93,2.47,15.89c-10.75-8.21-19.24-3.41-30-11.62Q275,42.85,273.78,34.9Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.06,46.67c-10.15-7.13-18.15-3.14-28.3-10.26q1.11,7.11,2.21,14.21c10.15,7.13,18.15,3.14,28.3,10.26Zm-25.74,3.85q-1-6.69-2.08-13.38c9.84,6.63,17.62,3,27.46,9.63q1,6.69,2.08,13.38C294.94,53.52,287.16,57.15,277.32,50.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.56,47.76a4.42,4.42,0,0,1,.9-3.51,4.05,4.05,0,0,1,3.75-1.17c2.66.33,5.74,3.29,6.26,6.45a4.25,4.25,0,0,1-.91,3.51,4.05,4.05,0,0,1-3.74,1.18h0a7.21,7.21,0,0,1-4.22-2.39A8.71,8.71,0,0,1,284.56,47.76Zm4.57-4.42a3.78,3.78,0,0,0-3.35.93,4.38,4.38,0,0,0-1,3.41c.51,3.09,3.51,6,6.1,6.27h0a3.75,3.75,0,0,0,3.46-1.1,4.14,4.14,0,0,0,.87-3.24,8.58,8.58,0,0,0-2-4A7.1,7.1,0,0,0,289.13,43.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.1,47.64a2.65,2.65,0,0,1,.5-2.23,3,3,0,0,1,2.47-.69,6.18,6.18,0,0,1,3.28,1.84,6.27,6.27,0,0,1,1.58,3.1,2.7,2.7,0,0,1-.5,2.22,3,3,0,0,1-2.47.69,6.21,6.21,0,0,1-4.86-4.93Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,50.37a2.66,2.66,0,0,0-1.15-1.65c-.27-.16-.43-.27-.65-.42l-1.12-7a1,1,0,0,0,.9,0,.88.88,0,0,0,.44-.86,28.47,28.47,0,0,0,6.51,2.17c-.13.11-.25.23-.37.35a6.29,6.29,0,0,0-1.18,5.16,10.6,10.6,0,0,0,2.22,5,27,27,0,0,1-5.51-2.1Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.33,45.89a.73.73,0,0,1,.26-.78,1.09,1.09,0,0,1,1,0A2.73,2.73,0,0,1,282.14,47a.86.86,0,0,1-.25.84.93.93,0,0,1-1,0,2.88,2.88,0,0,1-1.06-.89A2.57,2.57,0,0,1,279.33,45.89Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.08,54.67a6.18,6.18,0,0,0,.63-.59c1-1,1.34-2.76,1-4.87a10.7,10.7,0,0,0-2.28-5,27.69,27.69,0,0,1,5.46,2.08l.09.59a2.68,2.68,0,0,0,1.15,1.65c.27.16.43.27.65.42l1.14,7a1,1,0,0,0-.9,0,.87.87,0,0,0-.44.86A28.75,28.75,0,0,0,295.08,54.67Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.74,50.46a.9.9,0,0,1,.25-.84,1,1,0,0,1,1,0,2.93,2.93,0,0,1,1.56,2,.73.73,0,0,1-.26.79,1.07,1.07,0,0,1-1,0h0a2.81,2.81,0,0,1-1.05-.81A2.3,2.3,0,0,1,297.74,50.46Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bill--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.74,92.59c13.44-1.47,16.29-10.8,29.73-12.26l12.74,9.8c-13.44,1.47-16.29,10.8-29.73,12.27Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.06,80.94C442.8,82.77,439.75,91.18,427.49,93l11.4,8.78c12.26-1.84,15.31-10.24,27.57-12.08Zm-16,20.53q-5.35-4.14-10.73-8.26c11.7-2,14.83-10,26.53-11.95l10.73,8.25C453.9,91.5,450.77,99.49,439.07,101.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.41,94.48a4.44,4.44,0,0,1-1.76-3.16,4.05,4.05,0,0,1,1.9-3.44c2.16-1.59,6.43-1.57,9,.36a4.29,4.29,0,0,1,1.76,3.17,4,4,0,0,1-1.91,3.43h0a7.11,7.11,0,0,1-4.7,1.18A8.63,8.63,0,0,1,442.41,94.48Zm.27-6.35a3.79,3.79,0,0,0-1.8,3,4.44,4.44,0,0,0,1.65,3.15c2.5,1.89,6.65,1.88,8.74.33h0A3.75,3.75,0,0,0,453,91.41a4.13,4.13,0,0,0-1.6-2.94,8.45,8.45,0,0,0-4.16-1.5A7,7,0,0,0,442.68,88.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.44,93.33a2.7,2.7,0,0,1-1.17-2,3,3,0,0,1,1.31-2.2,6.16,6.16,0,0,1,3.65-.93,6.24,6.24,0,0,1,3.27,1.15,2.7,2.7,0,0,1,1.18,2,3.07,3.07,0,0,1-1.31,2.21,6.24,6.24,0,0,1-6.93-.23Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.9,99.53a2.63,2.63,0,0,0-2-.4l-.76.14-5.67-4.34a1,1,0,0,0,.68-.59.87.87,0,0,0-.27-.93,28,28,0,0,0,6.21-2.91c0,.17,0,.34,0,.51a6.29,6.29,0,0,0,2.7,4.55,10.63,10.63,0,0,0,5,2.06,26.88,26.88,0,0,1-5.43,2.27Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.34,96.73A.71.71,0,0,1,437,96a1.07,1.07,0,0,1,.75-.67,2.73,2.73,0,0,1,2.39.28.85.85,0,0,1,.4.78,1,1,0,0,1-.7.71,2.76,2.76,0,0,1-1.38.09A2.54,2.54,0,0,1,437.34,96.73Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.8,92.23c0-.31.05-.62.05-.86,0-1.43-.94-2.92-2.64-4.21a10.67,10.67,0,0,0-5.07-2,27.34,27.34,0,0,1,5.39-2.26l.48.37a2.64,2.64,0,0,0,2,.39l.75-.14,5.68,4.31a1,1,0,0,0-.68.59.87.87,0,0,0,.27.93A28.33,28.33,0,0,0,454.8,92.23Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.83,87.35a.91.91,0,0,1-.41-.79,1,1,0,0,1,.69-.72,3,3,0,0,1,2.49.35.73.73,0,0,1,.35.74,1.06,1.06,0,0,1-.74.68h0a2.74,2.74,0,0,1-1.31.14A2.26,2.26,0,0,1,453.83,87.35Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bill--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71,50.15c-1.66-16.46-20.88-1-22.54-17.44l-7.55,9.77c1.66,16.44,20.88,1,22.54,17.43Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.33,43.09c2.94,14.82,19.45.34,22.39,15.18l6.76-8.73C67.54,34.7,51,49.18,48.09,34.35Q44.72,38.73,41.33,43.09Zm11.4,7.33c-2.73-.31-10.09,0-11.13-7.07L48,35.13c1,7.09,8.39,6.76,11.13,7.07,2.51.29,10.3,0,11.12,7.07l-6.36,8.22C63,50.47,55.24,50.71,52.73,50.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.59,49.31a13.81,13.81,0,0,1-5.26.44h0c-1.14-.21-2.68-.25-3.66-1.77A2.34,2.34,0,0,1,50,45.21c1.86-2.13,5.72-2.75,8.52-2.33,1.11.16,2.68.25,3.66,1.76a2.43,2.43,0,0,1-.29,2.78A6.34,6.34,0,0,1,58.59,49.31Zm-5.21-5.87a6.45,6.45,0,0,0-3.23,1.94,2.19,2.19,0,0,0-.27,2.54c.92,1.41,2.39,1.36,3.45,1.55h0c2.83.29,6.61-.27,8.33-2.22a2.15,2.15,0,0,0,.18-2.56c-.93-1.4-2.49-1.39-3.53-1.54A11.49,11.49,0,0,0,53.38,43.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.89,47.6a3.88,3.88,0,0,0,1.73-1.19,1.07,1.07,0,0,0,.23-1.17,3,3,0,0,0-2.21-1l-.21,0a10.14,10.14,0,0,0-4.54.43c-.33.11-.65.22-1,.35a4,4,0,0,0-1.73,1.21A1.07,1.07,0,0,0,51,47.39a3,3,0,0,0,2.17,1l.26,0A10.69,10.69,0,0,0,58,48l.06,0C58.3,47.83,58.6,47.72,58.89,47.6Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.26,49.85c-.06-.24-.13-.42-.23-.71a2,2,0,0,1-.14-.8,1.35,1.35,0,0,1,.28-.82l.23-.3A6.79,6.79,0,0,0,63.56,44a4.42,4.42,0,0,1-.7,4.28,5.9,5.9,0,0,1-2.75,2.1l-.46.18a7.57,7.57,0,0,1,3.91,3,1,1,0,0,1,.23-.13.93.93,0,0,1,.75,0,1.21,1.21,0,0,1,.56.54Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.22,50.65a1.47,1.47,0,0,1-.81-.46,1.93,1.93,0,0,1-.54-1A1,1,0,0,1,64,48.4a1.1,1.1,0,0,1,1.62,0,1.69,1.69,0,0,1,.46,1.07,1.41,1.41,0,0,1-.25.95A.63.63,0,0,1,65.22,50.65Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.34,48.6c0-.08-.08-.15-.11-.22A4.09,4.09,0,0,1,49,44.33a5.67,5.67,0,0,1,2.65-2l.6-.22a7.48,7.48,0,0,1-3.89-2.89,1.2,1.2,0,0,1-.24.15,1,1,0,0,1-.75,0,1.23,1.23,0,0,1-.57-.54l-3.15,4a6.61,6.61,0,0,0,.24.71,2,2,0,0,1,.14.79,1.42,1.42,0,0,1-.28.82l-.23.3A6.84,6.84,0,0,0,48.34,48.6Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.11,44.81a1.21,1.21,0,0,1-.93-.32h0a1.6,1.6,0,0,1-.47-1.05,1.42,1.42,0,0,1,.24-.93c.35-.45,1-.31,1.47.18a1.9,1.9,0,0,1,.55.94.9.9,0,0,1-.15.82A1,1,0,0,1,47.11,44.81Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bill--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M488,198.83c6.41-17.22-21.31-7.08-14.91-24.29l-12.71,7.73c-6.41,17.2,21.32,7.07,14.91,24.29Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.57,183C456.3,199,480.71,189,476.44,205l11.37-6.91c4.27-15.94-20.13-6-15.87-22Zm8.27,10.77c-2.7-1.11-10.55-2.91-8.12-10.42l10.7-6.51c-2.42,7.51,5.43,9.31,8.12,10.43,2.48,1,10.74,3,8.12,10.42L477,204.23C479.57,196.85,471.32,194.83,468.84,193.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.5,194.38a15.29,15.29,0,0,1-5.7-1.09h0c-1.09-.54-2.67-1-2.95-2.86a2.92,2.92,0,0,1,1.68-2.74c3-1.62,7.33-1.12,10.05.12,1.08.49,2.67,1,2.95,2.86a3,3,0,0,1-1.68,2.73A8.44,8.44,0,0,1,475.5,194.38ZM473,186.9a8.78,8.78,0,0,0-4.32,1,2.73,2.73,0,0,0-1.55,2.51c.27,1.7,1.82,2.08,2.84,2.58h0c2.8,1.12,7,1.65,9.79.17a2.62,2.62,0,0,0,1.46-2.56c-.28-1.69-1.91-2.13-2.92-2.59A12.52,12.52,0,0,0,473,186.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.67,192.73a5.56,5.56,0,0,0,2.4-.71c.6-.36.87-.84.81-1.12-.17-.92-1.09-1.32-1.82-1.64l-.2-.09a11.13,11.13,0,0,0-5-.88c-.39,0-.79,0-1.19.07a5.6,5.6,0,0,0-2.4.72c-.6.36-.87.84-.81,1.12.17.9,1.06,1.3,1.78,1.62l.25.11a11.5,11.5,0,0,0,5,.88h.06C475.94,192.79,476.31,192.77,476.67,192.73Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.34,197.74a5.47,5.47,0,0,0,.1-.79,2.27,2.27,0,0,1,.26-.85,1.79,1.79,0,0,1,.69-.75l.39-.24a5.77,5.77,0,0,0-3.45-4.7c0,1.93-1.78,3.42-2.85,4.15a8.39,8.39,0,0,1-3.91,1.33l-.56,0a6.34,6.34,0,0,1,2.61,4.15,1.23,1.23,0,0,1,.32-.07,1,1,0,0,1,.77.23,1,1,0,0,1,.31.71Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.77,197.68a1.29,1.29,0,0,1-.62-.72,1.79,1.79,0,0,1-.09-1.12,1.22,1.22,0,0,1,.57-.8,1.18,1.18,0,0,1,1.7.45,1.62,1.62,0,0,1-.05,1.22,2,2,0,0,1-.73.89A.82.82,0,0,1,481.77,197.68Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.16,190.67a2.35,2.35,0,0,1,0-.26c.06-2,1.92-3.28,2.81-3.89a7.94,7.94,0,0,1,3.76-1.28l.74-.05a6.28,6.28,0,0,1-2.63-4.06,1.3,1.3,0,0,1-.33.07,1,1,0,0,1-.77-.23.93.93,0,0,1-.32-.71l-5.28,3.16a5.79,5.79,0,0,0-.11.79,2.08,2.08,0,0,1-.24.84,2,2,0,0,1-.69.76l-.39.23A5.81,5.81,0,0,0,465.16,190.67Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.75,186.47a1.13,1.13,0,0,1-.81-.6h0a1.52,1.52,0,0,1,0-1.2,1.9,1.9,0,0,1,.71-.89c.58-.35,1.15,0,1.44.62a1.84,1.84,0,0,1,.12,1.11,1.22,1.22,0,0,1-.57.79A1.35,1.35,0,0,1,465.75,186.47Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bill--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.68,109.66c15.58-2,18.69-12.89,34.27-14.88L71,105.9c-15.58,2-18.69,12.89-34.27,14.88Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.49,95.5c-14.21,2.39-17.57,12.22-31.77,14.61l13.43,10c14.2-2.39,17.57-12.22,31.77-14.62ZM37.36,119.69l-12.64-9.37c13.54-2.55,17-11.9,30.56-14.45l12.64,9.36C54.37,107.78,50.91,117.13,37.36,119.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.09,111.5A5.17,5.17,0,0,1,39,107.86a4.71,4.71,0,0,1,2.14-4c2.47-1.9,7.43-2,10.44.23a4.94,4.94,0,0,1,2.12,3.64,4.71,4.71,0,0,1-2.14,4h0a8.38,8.38,0,0,1-5.44,1.47A10.12,10.12,0,0,1,41.09,111.5Zm.17-7.38a4.37,4.37,0,0,0-2,3.5,5.13,5.13,0,0,0,2,3.62c2.94,2.14,7.76,2.05,10.16.2h0a4.36,4.36,0,0,0,2-3.74,4.78,4.78,0,0,0-1.92-3.38,9.83,9.83,0,0,0-4.86-1.65A8.22,8.22,0,0,0,41.26,104.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.26,110.14a3.08,3.08,0,0,1-1.4-2.25,3.53,3.53,0,0,1,1.47-2.59,7.33,7.33,0,0,1,4.22-1.16,7.23,7.23,0,0,1,3.83,1.28,3.08,3.08,0,0,1,1.4,2.25,3.5,3.5,0,0,1-1.47,2.58,7.2,7.2,0,0,1-8.05-.11Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.44,117.39a3.14,3.14,0,0,0-2.31-.42l-.88.19-6.68-4.93a1.12,1.12,0,0,0,.78-.7,1,1,0,0,0-.34-1.07,32.7,32.7,0,0,0,7.16-3.52c0,.2,0,.4,0,.6,0,1.74,1.26,3.74,3.23,5.23a12.43,12.43,0,0,0,5.88,2.28A32.3,32.3,0,0,1,40,117.81Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.24,114.22a.85.85,0,0,1-.42-.86,1.28,1.28,0,0,1,.85-.8,3.19,3.19,0,0,1,2.79.27,1,1,0,0,1,.48.9,1.08,1.08,0,0,1-.79.85,3.41,3.41,0,0,1-1.6.13A3.09,3.09,0,0,1,35.24,114.22Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.43,108.62a9.05,9.05,0,0,0,0-1c0-1.66-1.15-3.38-3.16-4.84a12.55,12.55,0,0,0-5.93-2.23,32,32,0,0,1,6.21-2.73l.56.42a3.07,3.07,0,0,0,2.3.41l.88-.18L63,103.35a1.17,1.17,0,0,0-.78.71,1,1,0,0,0,.34,1.07A33.22,33.22,0,0,0,55.43,108.62Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.19,103a1,1,0,0,1-.48-.91,1.09,1.09,0,0,1,.78-.84,3.41,3.41,0,0,1,2.9.34.85.85,0,0,1,.42.86,1.25,1.25,0,0,1-.84.81h0a3.27,3.27,0,0,1-1.53.18A2.63,2.63,0,0,1,54.19,103Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bill--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.34,89.42c16.65-2.51,19.72-14.27,36.37-16.79l16.37,11.56C262.42,86.7,259.36,98.46,242.7,101Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.34,89.42c16.65-2.51,19.72-14.27,36.37-16.79l16.37,11.56C262.42,86.7,259.36,98.46,242.7,101Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.24,73.41C247.07,76.33,243.7,87,228.54,89.86l14.64,10.33c15.17-2.91,18.53-13.53,33.7-16.44ZM243.4,99.79l-13.78-9.73C244.07,87,247.56,76.89,262,73.82l13.78,9.73C261.34,86.62,257.85,96.72,243.4,99.79Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.19,90.92a5.53,5.53,0,0,1-2.36-3.85A5.06,5.06,0,0,1,247,82.7c2.6-2.09,7.91-2.29,11.2,0a5.32,5.32,0,0,1,2.36,3.85,5,5,0,0,1-2.2,4.37h0a8.92,8.92,0,0,1-5.79,1.71A10.79,10.79,0,0,1,247.19,90.92Zm0-7.91a4.69,4.69,0,0,0-2.07,3.8,5.48,5.48,0,0,0,2.21,3.83c3.2,2.22,8.37,2,10.89,0h0a4.69,4.69,0,0,0,2-4A5.18,5.18,0,0,0,258.09,83a10.42,10.42,0,0,0-5.25-1.64A8.76,8.76,0,0,0,247.19,83Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.41,89.44a3.35,3.35,0,0,1-1.55-2.38,3.75,3.75,0,0,1,1.51-2.81,7.83,7.83,0,0,1,4.5-1.35A7.65,7.65,0,0,1,257,84.18a3.32,3.32,0,0,1,1.56,2.37A3.73,3.73,0,0,1,257,89.36a7.51,7.51,0,0,1-4.49,1.35A7.65,7.65,0,0,1,248.41,89.44Z",
    style: {
      fill: "#76ABAE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M245.57,97.28a3.29,3.29,0,0,0-2.48-.39c-.38.09-.62.15-.94.21L234.86,92a1.19,1.19,0,0,0,.82-.77,1.09,1.09,0,0,0-.38-1.14,35.5,35.5,0,0,0,7.58-3.94c0,.21,0,.42,0,.64.07,1.86,1.44,4,3.59,5.52a13.35,13.35,0,0,0,6.36,2.3,33.82,33.82,0,0,1-6.65,3.11Z",
    style: {
      fill: "#76ABAE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241,94a.88.88,0,0,1-.47-.91,1.33,1.33,0,0,1,.89-.87,3.41,3.41,0,0,1,3,.21,1.11,1.11,0,0,1,.54,1,1.16,1.16,0,0,1-.84.92,3.57,3.57,0,0,1-1.71.18A3.27,3.27,0,0,1,241,94Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M262.49,87.49a10.28,10.28,0,0,0,0-1.08c-.08-1.77-1.33-3.59-3.51-5.11a13.38,13.38,0,0,0-6.41-2.24A34.36,34.36,0,0,1,259.19,76l.61.43a3.31,3.31,0,0,0,2.47.39l.94-.22,7.28,5.08a1.17,1.17,0,0,0-.81.77,1.07,1.07,0,0,0,.38,1.14A35,35,0,0,0,262.49,87.49Z",
    style: {
      fill: "#76ABAE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261,81.46a1.11,1.11,0,0,1-.54-1,1.18,1.18,0,0,1,.82-.93,3.66,3.66,0,0,1,3.11.3.93.93,0,0,1,.48.91,1.35,1.35,0,0,1-.89.89h0a3.54,3.54,0,0,1-1.63.23A2.77,2.77,0,0,1,261,81.46Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bill--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.24,57.11c-16.2-4.61-17.75-16.66-34-21.27L139.6,45.22c16.2,4.61,17.75,16.66,34,21.27Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.24,57.11c-16.2-4.61-17.75-16.66-34-21.27L139.6,45.22c16.2,4.61,17.75,16.66,34,21.27Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.83,45.07c14.68,4.81,16.67,15.77,31.34,20.58L189,57.26c-14.68-4.81-16.67-15.77-31.34-20.59Zm1.1-.06,14.9-7.91C171.78,42,174,52.45,187.91,57.32q-7.44,4-14.9,7.9C159.06,60.35,156.88,49.88,142.93,45Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.79,57a9,9,0,0,1-5.53-2.43h0a5,5,0,0,1-1.62-4.62,5.32,5.32,0,0,1,2.83-3.52c3.54-1.84,8.79-1,11.11,1.43a5.07,5.07,0,0,1,1.62,4.62A5.53,5.53,0,0,1,170.37,56,10.87,10.87,0,0,1,164.79,57ZM166,45.71a10.5,10.5,0,0,0-5.42,1A5.15,5.15,0,0,0,158,50a4.65,4.65,0,0,0,1.48,4.27h0c2.24,2.35,7.34,3.22,10.8,1.42A5.48,5.48,0,0,0,173,52.13a4.7,4.7,0,0,0-1.58-4A8.78,8.78,0,0,0,166,45.71Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.08,55.06a7.58,7.58,0,0,1-4.28-1.91,3.72,3.72,0,0,1-1.15-3A3.32,3.32,0,0,1,161.49,48a7.79,7.79,0,0,1,4.27-.74A7.71,7.71,0,0,1,170,49.18a3.72,3.72,0,0,1,1.15,3,3.32,3.32,0,0,1-1.84,2.16A7.59,7.59,0,0,1,165.08,55.06Z",
    style: {
      fill: "#76ABAE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.18,62.46a3.29,3.29,0,0,1,2.51-.07l.9.33,7.88-4.15a1.2,1.2,0,0,1-.72-.87,1.08,1.08,0,0,1,.53-1.08,35.06,35.06,0,0,1-7-4.87c0,.21,0,.42-.08.63-.3,1.84-1.93,3.77-4.26,5a13.22,13.22,0,0,1-6.6,1.48,33.46,33.46,0,0,0,6.2,3.93Z",
    style: {
      fill: "#76ABAE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.67,60.07a3.49,3.49,0,0,1-1.67-.39,1.16,1.16,0,0,1-.71-1,1.07,1.07,0,0,1,.65-.88,3.42,3.42,0,0,1,3,.16,1.35,1.35,0,0,1,.78,1,.92.92,0,0,1-.58.84A3.19,3.19,0,0,1,174.67,60.07Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M155.63,50.6a9.85,9.85,0,0,1,.11-1.07c.3-1.75,1.77-3.39,4.13-4.62a13.43,13.43,0,0,1,6.64-1.42,33.69,33.69,0,0,0-6.15-3.88l-.66.34a3.31,3.31,0,0,1-2.5.08l-.9-.34-7.86,4.11a1.19,1.19,0,0,1,.7.87,1.07,1.07,0,0,1-.52,1.08A36,36,0,0,1,155.63,50.6Z",
    style: {
      fill: "#76ABAE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.44,45.08a3.53,3.53,0,0,1-1.58-.45h0a1.37,1.37,0,0,1-.77-1,.92.92,0,0,1,.59-.85,3.64,3.64,0,0,1,3.12.1,1.17,1.17,0,0,1,.7,1,1.1,1.1,0,0,1-.66.89A2.86,2.86,0,0,1,156.44,45.08Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bill--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.3,58c-16.84-.11-21.56-11.3-38.4-11.42L373.35,60.32c16.85.12,21.56,11.31,38.4,11.43Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.3,58c-16.84-.11-21.56-11.3-38.4-11.42L373.35,60.32c16.85.12,21.56,11.31,38.4,11.43Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.47,59.58c15.43.72,20.27,10.74,35.7,11.46l13-12.32C408.76,58,403.91,48,388.48,47.26Zm1-.35,12.25-11.6c14.74,1,19.64,10.47,34.39,11.44L410.9,70.67C396.15,69.7,391.26,60.2,376.51,59.23Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.77,64.89a9,9,0,0,1-6-.87h0a5,5,0,0,1-2.8-4,5.28,5.28,0,0,1,1.79-4.15c2.92-2.72,8.21-3.29,11.08-1.58a5.05,5.05,0,0,1,2.8,4,5.58,5.58,0,0,1-1.78,4.15A11,11,0,0,1,400.77,64.89Zm-1.85-11.14a10.46,10.46,0,0,0-5,2.37A5.17,5.17,0,0,0,392.34,60a4.68,4.68,0,0,0,2.57,3.73h0c2.79,1.66,7.94,1.13,10.79-1.52a5.51,5.51,0,0,0,1.64-4.11,4.72,4.72,0,0,0-2.6-3.47A8.79,8.79,0,0,0,398.92,53.75Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.54,63a7.6,7.6,0,0,1-4.64-.69,3.75,3.75,0,0,1-1.9-2.57,3.32,3.32,0,0,1,1.2-2.57A7.76,7.76,0,0,1,403.75,56a3.75,3.75,0,0,1,1.9,2.57,3.32,3.32,0,0,1-1.2,2.57A7.57,7.57,0,0,1,400.54,63Z",
    style: {
      fill: "#76ABAE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M408.39,68.5a3.32,3.32,0,0,1,2.4-.75l1,.08,6.48-6.1a1.19,1.19,0,0,1-.92-.64,1.09,1.09,0,0,1,.22-1.19,34.81,34.81,0,0,1-8.07-2.82c0,.21.07.42.1.64.2,1.85-.86,4.14-2.77,6a13.23,13.23,0,0,1-6,3.19,33.43,33.43,0,0,0,7,2.13Z",
    style: {
      fill: "#76ABAE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.12,65.26a3.49,3.49,0,0,1-1.72.07,1.17,1.17,0,0,1-.95-.79,1.08,1.08,0,0,1,.39-1,3.39,3.39,0,0,1,2.93-.65,1.37,1.37,0,0,1,1,.74.92.92,0,0,1-.34,1A3.16,3.16,0,0,1,411.12,65.26Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M390.24,61.22a10.7,10.7,0,0,1-.18-1.06c-.18-1.77.8-3.74,2.75-5.55a13.32,13.32,0,0,1,6-3.14,33.72,33.72,0,0,0-7-2.11l-.54.52a3.36,3.36,0,0,1-2.39.74c-.39,0-.63-.07-1-.09l-6.48,6.06a1.22,1.22,0,0,1,.92.65,1.09,1.09,0,0,1-.22,1.18A35.62,35.62,0,0,1,390.24,61.22Z",
    style: {
      fill: "#76ABAE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.55,55.68a3.54,3.54,0,0,1-1.65,0h0a1.38,1.38,0,0,1-1-.75.91.91,0,0,1,.34-1,3.69,3.69,0,0,1,3-.74,1.16,1.16,0,0,1,.94.8,1.08,1.08,0,0,1-.4,1A2.67,2.67,0,0,1,389.55,55.68Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bill--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.13,306.57c4.81-16.14,16.88-17.53,21.7-33.67l-9.15-17.82c-4.82,16.14-16.89,17.53-21.71,33.67Q462.56,297.66,467.13,306.57Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.13,306.57c4.81-16.14,16.88-17.53,21.7-33.67l-9.15-17.82c-4.82,16.14-16.89,17.53-21.71,33.67Q462.56,297.66,467.13,306.57Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.8,257.32c-5,14.61-16,16.46-21,31.07L467,304.33c5-14.61,16-16.46,21-31.07Zm.05,1.09,7.71,15C482.5,287.31,472,289.35,467,303.23q-3.84-7.5-7.7-15C464.3,274.34,474.8,272.3,479.85,258.41Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.63,280.12a9,9,0,0,1,2.5-5.5h0a5,5,0,0,1,4.64-1.56,5.32,5.32,0,0,1,3.48,2.87c1.8,3.57.86,8.81-1.58,11.09a5,5,0,0,1-4.63,1.56,5.5,5.5,0,0,1-3.48-2.87A10.75,10.75,0,0,1,467.63,280.12Zm11.22,1.34A10.58,10.58,0,0,0,478,276a5.17,5.17,0,0,0-3.24-2.63,4.7,4.7,0,0,0-4.3,1.43h0c-2.37,2.22-3.3,7.3-1.56,10.79a5.57,5.57,0,0,0,3.49,2.72,4.68,4.68,0,0,0,4.05-1.53A8.74,8.74,0,0,0,478.85,281.46Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M469.52,280.43a7.54,7.54,0,0,1,2-4.26,3.79,3.79,0,0,1,3-1.11,3.37,3.37,0,0,1,2.14,1.88,7.8,7.8,0,0,1,.68,4.27,7.71,7.71,0,0,1-2,4.26,3.77,3.77,0,0,1-3,1.11,3.33,3.33,0,0,1-2.13-1.87A7.61,7.61,0,0,1,469.52,280.43Z",
    style: {
      fill: "#76ABAE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M462,286.43a3.29,3.29,0,0,1,.05,2.51c-.15.36-.24.59-.35.9l4,7.93a1.19,1.19,0,0,1,.88-.7,1.07,1.07,0,0,1,1.08.54,35.36,35.36,0,0,1,5-7l-.63-.08c-1.84-.33-3.74-2-5-4.33a13.34,13.34,0,0,1-1.39-6.62,34,34,0,0,0-4,6.15Z",
    style: {
      fill: "#76ABAE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.37,290a3.62,3.62,0,0,1,.42-1.67,1.18,1.18,0,0,1,1-.7,1.09,1.09,0,0,1,.87.67,3.41,3.41,0,0,1-.2,3,1.37,1.37,0,0,1-1,.77.91.91,0,0,1-.84-.59A3.35,3.35,0,0,1,464.37,290Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M474.09,271a9.22,9.22,0,0,1,1.07.13c1.75.32,3.37,1.81,4.57,4.18a13.37,13.37,0,0,1,1.33,6.66,34.23,34.23,0,0,0,4-6.09l-.34-.67a3.27,3.27,0,0,1,0-2.5l.35-.9-4-7.91a1.19,1.19,0,0,1-.88.69,1.08,1.08,0,0,1-1.08-.54A35.13,35.13,0,0,1,474.09,271Z",
    style: {
      fill: "#76ABAE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M479.61,271.93a3.5,3.5,0,0,1,.46-1.58h0a1.38,1.38,0,0,1,1-.76.94.94,0,0,1,.84.61,3.68,3.68,0,0,1-.14,3.12,1.2,1.2,0,0,1-1,.68,1.11,1.11,0,0,1-.87-.67A2.77,2.77,0,0,1,479.61,271.93Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bill--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.68,229.86c-2.52-23.77,29.24-7.58,26.72-31.34L63,210.09c2.53,23.76-29.24,7.57-26.72,31.35Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.68,229.86c-2.52-23.77,29.24-7.58,26.72-31.34L63,210.09c2.53,23.76-29.24,7.57-26.72,31.35Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.34,200.75c.24,21.84-27.41,6.25-27.17,28.11l12.14,10.35c-.23-21.86,27.41-6.27,27.18-28.11ZM34.9,238.14,23.47,228.4c-.92-10.18,10.18-12.14,13.64-13.29,3.77-1.26,14.28-3,13.65-13.3l11.42,9.75c.64,10.33-9.87,12-13.64,13.29C45.07,226,34,228,34.9,238.14Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.75,223.3a3.49,3.49,0,0,1-1.24-3.83c.94-2.44,3.13-3,4.65-3.59,3.85-1.41,9.49-1.68,12.75.77a3.4,3.4,0,0,1,1.23,3.84c-.94,2.43-3.1,3-4.65,3.58h0a20.11,20.11,0,0,1-7.56,1C38.14,224.81,36.33,224.62,34.75,223.3Zm3.74-7.09c-1.43.53-3.64,1-4.53,3.23A3.1,3.1,0,0,0,35,223c3,2.25,8.53,1.92,12.43.67h0c1.45-.58,3.54-1,4.43-3.21A3.18,3.18,0,0,0,50.69,217a9.38,9.38,0,0,0-5.13-1.78A16.6,16.6,0,0,0,38.49,216.21Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39,222.69a5.73,5.73,0,0,1-2.8-1.18,1.53,1.53,0,0,1-.67-1.59,4.32,4.32,0,0,1,2.83-2l.28-.1a14.82,14.82,0,0,1,6.57-.73c.48,0,1,.11,1.47.2a5.81,5.81,0,0,1,2.8,1.2,1.53,1.53,0,0,1,.67,1.58,4.26,4.26,0,0,1-2.78,2l-.35.13a15.38,15.38,0,0,1-6.59.73l-.09,0C39.88,222.83,39.43,222.77,39,222.69Z",
    style: {
      fill: "#76ABAE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.4,228.65a9.36,9.36,0,0,1,.12-1.08,2.85,2.85,0,0,0,0-1.17,2,2,0,0,0-.64-1.08l-.41-.35a9.8,9.8,0,0,1,5.89-6c-.63,2.6,1.14,4.78,2.25,5.85A8.64,8.64,0,0,0,38.08,227c.23.05.47.08.71.11a11,11,0,0,0-4.66,5.34,1.23,1.23,0,0,0-.37-.12,1.34,1.34,0,0,0-1.06.24,1.73,1.73,0,0,0-.62.93Z",
    style: {
      fill: "#76ABAE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,228.7a2.1,2.1,0,0,1-.63-1.26,2.34,2.34,0,0,1,.33-1.65,1.6,1.6,0,0,1,2.3-.45,1.41,1.41,0,0,1,.46,1.13A3,3,0,0,1,32,228a2.15,2.15,0,0,1-1,.9A.91.91,0,0,1,30,228.7Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.2,221a1.69,1.69,0,0,0,.1-.35c.58-2.73-1.36-4.59-2.29-5.49a8.19,8.19,0,0,0-4.34-2.07l-.92-.14a10.73,10.73,0,0,0,4.64-5.23,1.49,1.49,0,0,0,.39.13,1.38,1.38,0,0,0,1.06-.23,1.71,1.71,0,0,0,.63-.93l5.66,4.74a9,9,0,0,1-.13,1.06,2.82,2.82,0,0,0,0,1.16,2.05,2.05,0,0,0,.63,1.08l.42.36A9.87,9.87,0,0,1,54.2,221Z",
    style: {
      fill: "#76ABAE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.71,215a1.38,1.38,0,0,1-.46-1.12,2.9,2.9,0,0,1,.51-1.49c.58-.84,1.4-1.22,2-.69a2,2,0,0,1,.61,1.25,2.3,2.3,0,0,1-.35,1.62h0a1.71,1.71,0,0,1-1.22.73A1.39,1.39,0,0,1,53.71,215Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--banknotes-1--inject-159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Money--inject-159"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "323.61 96.56 323.62 324.04 422.12 380.91 422.11 153.43 323.61 96.56",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.61 96.56 323.62 324.04 422.12 380.91 422.11 153.43 323.61 96.56",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.94,371.93V156.42l-88.14-50.89V321Zm-2.6-4.49-82.95-47.89V110l82.94,47.89Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M396.53,220.82c6.71,11.63,10.92,25.11,10.92,37.37h0c0,11.93-4.09,21.14-11.22,25.25-6.53,3.78-15,3.05-23.8-2-18.83-10.87-34.14-38.74-34.14-62.13,0-11.93,4.09-21.14,11.21-25.25,6.54-3.77,15-3.05,23.81,2S390.44,210.26,396.53,220.82Zm-45.82,35c5.94,10.28,13.88,19.07,22.6,24.1,8.25,4.76,16.08,5.49,22,2.05,6.57-3.8,10.33-12.45,10.33-23.73h0c0-22.83-14.91-50-33.25-60.6-8.25-4.76-16.08-5.49-22-2-6.57,3.79-10.34,12.44-10.34,23.72C340.05,231.25,344.16,244.42,350.71,255.77Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391,224c6.38,11.05,10,23.51,10,34.19,0,9.59-2.93,16.78-8,19.73-4.47,2.58-10.66,1.86-17.42-2.05-7.71-4.45-15.14-12.41-20.91-22.41-6.38-11.05-10-23.51-10-34.18,0-9.6,2.92-16.79,8-19.74,4.48-2.58,10.67-1.85,17.43,2.05C377.83,206,385.25,214,391,224Z",
    style: {
      fill: "#76ABAE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M410.41,172.16l-.17,62.63-1.68-4a92.89,92.89,0,0,0-5.19-10.49c-7.09-12.26-18.88-22.73-27.43-27.67-9.58-5.53-23-9-31.35-4.13a23.35,23.35,0,0,0-7.32,6.75l-1.6,2.27.16-68.57,6.51,3.75a2.31,2.31,0,0,0,3.86-2.23v-7.52L400,154.2v6.49a10.53,10.53,0,0,0,4.74,8.23Z",
    style: {
      fill: "#76ABAE",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.45,162.51a18.46,18.46,0,0,1,2.61,8.93c0,3-1.06,5.33-2.92,6.4s-3.91.83-6.15-.47c-4.52-2.61-8.2-9.29-8.2-14.88,0-3,1.06-5.33,2.92-6.4s3.91-.83,6.16.47A16.16,16.16,0,0,1,379.45,162.51Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M409.94,279.9l.08,68.3-6.51-3.76a2.31,2.31,0,0,0-3.86,2.23v7.52l-53.56-31.34v-6.49a10.64,10.64,0,0,0-4.74-8.21l-5.63-3.24-.08-62.47,1.7,4.08a93.07,93.07,0,0,0,5.2,10.5C349,268.13,360,279.46,370,285.22c12.47,7.2,22.32,8.82,29.27,4.8a33.7,33.7,0,0,0,9.12-7.89Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.7,305.52a18.57,18.57,0,0,1,2.61,8.93h0c0,3-1.06,5.33-2.92,6.4s-3.91.83-6.16-.47c-4.52-2.61-8.19-9.28-8.19-14.88,0-3,1.06-5.33,2.92-6.4s3.91-.83,6.16.47A16.24,16.24,0,0,1,379.7,305.52Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M422.11,251.31s.57-73.46-2.21-96.51c-30.17-18.18-60.07-35.58-93.91-53.9l-2.38,93.55Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.61 96.56 348.47 82.21 446.97 139.08 422.11 153.43 323.61 96.56",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.61 96.56 348.47 82.21 446.97 139.08 422.11 153.43 323.61 96.56",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "429.2 149.33 398.67 131.05 430.46 148.61 429.2 149.33",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.93 89.45 346.82 95.13 336.98 88.84 335.93 89.45",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.88 86.59 393.47 116.08 342.4 85.71 340.88 86.59",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.14 146.49 383.11 116.08 435.77 145.55 434.14 146.49",
    style: {
      fill: "#76ABAE"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "446.97 139.08 446.97 366.56 422.12 380.91 422.11 153.43 446.97 139.08",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.97 139.08 446.97 366.56 422.12 380.91 422.11 153.43 446.97 139.08",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "429.2 149.33 429.77 160.99 430.46 148.61 429.2 149.33",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.14 146.49 434.97 206.2 435.77 145.55 434.14 146.49",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.35 373.85 434.96 331.59 435.57 373.14 434.35 373.85",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.56 370.84 440.14 346.56 440.72 370.17 439.56 370.84",
    style: {
      fill: "#76ABAE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M422.11,251.31s0-.48-.09-13.21c-.25-17.86-1.09-59.28-4.41-82.08a553.52,553.52,0,0,0-107.54-52.24c7.35,29.91,12.81,59.93,13.55,90.7Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.11,251.31s0-.48-.09-13.21c-.25-17.86-1.09-59.28-4.41-82.08a553.52,553.52,0,0,0-107.54-52.24c7.35,29.91,12.81,59.93,13.55,90.7Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.91,248.31c0-30.27-.25-60.23-4.26-90.29-29.76-18.48-63.22-35.23-95-46.67,8,28.14,11.1,56.92,11.15,86.11l2.62,1.43a369.49,369.49,0,0,0-10.21-84C351,127,382.38,141.84,410.48,159.42c3.88,29.11,3.92,58.1,3.86,87.41C415.21,247.32,416.05,247.83,416.91,248.31Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M405.14,241.52c-1.22-5.63-3.15-12.06-9.43-22.92A60.94,60.94,0,0,0,375.46,197c-8.79-5.48-14.7-7.11-23.54-4.17-5.26,1.75-9,7.71-11,11.6l1.54.88c1.56-3.15,4.78-9.07,10.09-10.82,8.36-2.76,15.1-.22,22.51,4.71,12.52,8.33,22.5,23.11,27.93,41Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397,236.81a83.11,83.11,0,0,0-5.51-12.37C385,213.6,379,207.59,371.42,203c-6.87-4.18-11.79-6.14-18.38-3.61-2.78,1.07-5.73,5.32-6.57,8.32Z",
    style: {
      fill: "#76ABAE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M410.29,234.73c.67-20.63,1.23-41.17-1.49-61.71a24.55,24.55,0,0,1-5.58-3.31,17,17,0,0,1-5.69-8.29,23,23,0,0,1-.95-6.15c-19.33-12.9-38.5-19.66-57.34-28.34.55,2.33.82,3.68,1.11,5.6.2,1.3.51,2.8-.28,3.52-1,.89-2.27.3-3.63-.28a70.61,70.61,0,0,1-6.48-3.21c5.12,22.47,5.85,41.78,5.79,64.75,0,0,.51-.82,1.84-2.55a22.51,22.51,0,0,1,7.52-5.89c10.89-5.43,21.66-3,33,3.87,10.12,6.09,17.77,15.79,24.68,26.13a57.12,57.12,0,0,1,5.67,10.42A42.36,42.36,0,0,1,410.29,234.73Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.15,177.45c2.33-1.27,3.16-3,2.88-5.7a20,20,0,0,0-3-8.6c-1.61-2.25-3.17-4.34-5.43-5.52s-4.61-2-6.71-.48-2.42,4.91-2,7.74c.69,4.53,2.26,7.58,6.55,11C372.53,177.56,376.28,178.46,378.15,177.45Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "320.17 192.47 422.11 251.31 422.12 287.22 320.17 228.38 320.17 192.47",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.12 287.22 448.79 271.82 448.79 235.91 422.11 251.31 422.12 287.22",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "448.79 235.91 446.97 234.86 446.97 236.96 448.79 235.91",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.17 192.47 323.5 190.55 323.61 194.46 320.17 192.47",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "446.96 234.87 422.12 249.21 422.11 251.31 446.96 236.97 446.96 234.87"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "422.12 249.21 323.56 192.31 323.61 194.46 422.11 251.31 422.12 249.21"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "320.17 196.34 422.11 255.2 422.11 258.18 320.18 199.33 320.17 196.34",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.18 221.49 422.12 280.35 422.12 283.34 320.19 224.48 320.18 221.49",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.11 255.2 448.79 239.79 448.79 242.78 422.11 258.18 422.11 255.2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.12 280.35 448.79 264.95 448.79 267.95 422.12 283.34 422.12 280.35",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--money--inject-159"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "41.48 362.95 238.49 249.22 336.99 306.09 139.98 419.82 41.48 362.95",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.48 362.95 238.49 249.22 336.99 306.09 139.98 419.82 41.48 362.95",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.49,255.2,51.84,363,140,413.84,326.62,306.09ZM140,410.84,57,363,238.49,258.2l82.94,47.89Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.5,356.24c-8.82-5.09-13.67-12.05-13.67-19.59,0-8.23,5.93-16.38,16.26-22.34,20.26-11.7,52-12.37,70.87-1.5,8.82,5.09,13.68,12.05,13.68,19.59,0,8.23-5.93,16.38-16.27,22.34h0C212.76,360.87,199,364,185.55,364,173.36,364,161.46,361.41,152.5,356.24ZM156,315.83c-9.78,5.65-15.39,13.23-15.39,20.82,0,6.88,4.55,13.3,12.8,18.06,18.33,10.59,49.33,9.92,69.1-1.49h0c9.78-5.65,15.38-13.24,15.38-20.82,0-6.88-4.54-13.3-12.79-18.06-8.72-5-20.3-7.53-32.17-7.53C179.81,306.81,166.35,309.85,156,315.83Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.69,350.71c-6.76-3.9-10.48-8.89-10.48-14.06,0-5.89,4.76-12,13.08-16.82,9.24-5.34,21.86-8.4,34.62-8.4,11.55,0,22.15,2.45,29.86,6.9,6.76,3.91,10.49,8.9,10.49,14.07,0,5.89-4.77,12-13.08,16.82-9.24,5.34-21.86,8.4-34.62,8.4C174,357.62,163.4,355.16,155.69,350.71Z",
    style: {
      fill: "#76ABAE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M144.73,397.06a10.56,10.56,0,0,0-9.5,0l-5.62,3.24-54-31,6.51-3.75a2.31,2.31,0,0,0,0-4.46l-6.51-3.76,59.31-34.43-1.16,2.53a23.25,23.25,0,0,0-2.19,9.71c0,9.65,9.67,19.55,19.25,25.08,8.55,4.94,23.52,9.92,37.68,9.92a91,91,0,0,0,11.68-.75l4.34-.55-54.16,31.45Z",
    style: {
      fill: "#76ABAE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.57,376.48c-2.25-1.3-3.49-3.11-3.49-5.1s1.49-4.23,4.08-5.73c4.85-2.8,12.47-2.95,17-.34,2.25,1.29,3.49,3.1,3.49,5.09,0,2.15-1.49,4.23-4.09,5.73a18.42,18.42,0,0,1-9,2.21A16.23,16.23,0,0,1,118.57,376.48Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M244.56,343.55a33.75,33.75,0,0,0,2.28-11.84c0-8-6.33-15.75-18.8-22.95-10-5.77-25.3-9.64-38.13-9.64a92.42,92.42,0,0,0-11.69.74l-4.39.57L228,269.27l5.62,3.25a10.68,10.68,0,0,0,9.48,0l5.62-3.25L302.62,300l-6.52,3.77a2.31,2.31,0,0,0,0,4.46l6.51,3.75-59.19,34.09Z",
    style: {
      fill: "#76ABAE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.54,305.19c-2.24-1.3-3.48-3.11-3.48-5.1,0-2.15,1.49-4.23,4.08-5.73,4.85-2.8,12.47-2.95,17-.35,2.25,1.3,3.48,3.11,3.48,5.1,0,2.15-1.48,4.23-4.08,5.73h0a18.48,18.48,0,0,1-9,2.21A16.3,16.3,0,0,1,242.54,305.19Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "41.48 362.95 41.48 391.65 139.98 448.52 139.98 419.82 41.48 362.95",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.48 362.95 41.48 391.65 139.98 448.52 139.98 419.82 41.48 362.95",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "139.98 428.01 108.88 410.71 139.98 429.46 139.98 428.01"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "41.48 377.18 51.85 383.77 41.48 378.39 41.48 377.18"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "41.48 382.88 93.32 413.69 41.48 384.65 41.48 382.88"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "139.98 433.71 88.14 404.72 139.98 435.59 139.98 433.71"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "139.98 448.52 336.99 334.79 336.99 306.09 139.98 419.82 139.98 448.52",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.98 448.52 336.99 334.79 336.99 306.09 139.98 419.82 139.98 448.52",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.98 428.01 150.36 422.67 139.98 429.46 139.98 428.01",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.98 433.71 192.11 404.58 139.98 435.59 139.98 433.71",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.99 320.21 300.69 341.87 336.99 321.62 336.99 320.21",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.99 326.23 316.25 338.87 336.99 327.57 336.99 326.23",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.82 312.02 224.75 370.88 255.85 352.93 153.93 294.06 122.82 312.02",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.85 352.93 255.85 383.73 224.75 401.69 224.75 370.88 255.85 352.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.75 401.69 222.93 400.63 224.75 399.58 224.75 401.69",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.82 312.02 122.82 316 126.26 314.01 122.82 312.02",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "222.93 400.62 222.93 371.94 224.75 370.88 224.75 399.57 222.93 400.62"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "222.93 371.94 124.44 315.06 126.26 314.01 224.75 370.88 222.93 371.94"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "126.17 310.09 228.12 368.94 230.7 367.44 128.77 308.6 126.17 310.09",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.96 297.52 249.9 356.37 252.49 354.87 150.56 296.03 147.96 297.52",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.12 368.94 228.12 399.74 230.7 398.25 230.7 367.44 228.12 368.94",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.9 356.37 249.9 387.17 252.5 385.67 252.49 354.87 249.9 356.37",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--money--inject-159"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-159",
    points: "336.99 306.09 336.99 313.54 148.31 422.47 148.31 415.01 139.98 419.82 139.98 448.52 41.48 391.65 41.48 362.95 234.46 251.54 336.99 306.09",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.28 328.06 249.28 214.32 347.78 271.19 150.78 384.92 52.28 328.06",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.28 328.06 249.28 214.32 347.78 271.19 150.78 384.92 52.28 328.06",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.28,220.31,62.64,328.05l88.14,50.89L337.42,271.19ZM150.77,375.94,67.83,328.05,249.28,223.3l83,47.89Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.3,321.34c-8.82-5.09-13.68-12-13.68-19.59,0-8.23,5.93-16.37,16.27-22.34,20.25-11.7,52.05-12.37,70.87-1.5,8.82,5.09,13.68,12,13.68,19.59,0,8.23-5.93,16.38-16.27,22.34h0c-10.62,6.13-24.4,9.23-37.82,9.23C184.16,329.07,172.26,326.51,163.3,321.34Zm3.47-40.41c-9.77,5.65-15.38,13.24-15.38,20.82,0,6.89,4.54,13.3,12.79,18.07,18.34,10.58,49.34,9.91,69.11-1.5h0c9.77-5.65,15.38-13.23,15.38-20.82,0-6.88-4.54-13.3-12.79-18.06-8.72-5-20.3-7.52-32.17-7.52C190.6,271.92,177.14,275,166.77,280.93Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.49,315.81c-6.76-3.9-10.48-8.89-10.48-14.06,0-5.89,4.76-12,13.07-16.82,9.25-5.34,21.87-8.4,34.63-8.4,11.54,0,22.15,2.45,29.86,6.91,6.76,3.9,10.48,8.9,10.48,14.06,0,5.89-4.76,12-13.07,16.82-9.25,5.34-21.87,8.4-34.62,8.4C184.81,322.72,174.2,320.27,166.49,315.81Z",
    style: {
      fill: "#76ABAE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M155.53,362.17a10.53,10.53,0,0,0-9.5,0l-5.62,3.24-54-31,6.51-3.75a2.84,2.84,0,0,0,1.72-2.24c0-.79-.61-1.58-1.72-2.22l-6.5-3.76L145.71,288l-1.16,2.53a23.12,23.12,0,0,0-2.2,9.72c0,9.65,9.67,19.54,19.26,25.07,8.55,4.94,23.51,9.92,37.67,9.92a92.62,92.62,0,0,0,11.68-.74l4.34-.56-54.15,31.45Z",
    style: {
      fill: "#76ABAE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.37,341.58c-2.25-1.3-3.49-3.11-3.49-5.1,0-2.14,1.49-4.23,4.08-5.73,4.85-2.8,12.47-2.95,17-.34,2.25,1.3,3.48,3.11,3.48,5.09,0,2.15-1.48,4.24-4.08,5.73a18.45,18.45,0,0,1-9,2.21A16.23,16.23,0,0,1,129.37,341.58Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M255.36,308.65a34,34,0,0,0,2.27-11.84c0-8-6.32-15.75-18.79-22.95-10-5.76-25.3-9.64-38.13-9.64A90.75,90.75,0,0,0,189,265l-4.38.56,54.14-31.16,5.62,3.25a10.68,10.68,0,0,0,9.48,0l5.62-3.26,53.92,30.71-6.51,3.78a2.79,2.79,0,0,0-1.7,2.22,2.83,2.83,0,0,0,1.7,2.23l6.51,3.75-59.19,34.09Z",
    style: {
      fill: "#76ABAE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.34,270.29c-2.25-1.3-3.48-3.11-3.48-5.1s1.48-4.23,4.08-5.73c4.85-2.8,12.47-2.95,17-.34,2.25,1.29,3.49,3.1,3.49,5.09,0,2.15-1.49,4.24-4.08,5.73h0a18.49,18.49,0,0,1-9.05,2.21A16.29,16.29,0,0,1,253.34,270.29Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "52.28 328.06 52.28 356.75 150.78 413.62 150.78 384.92 52.28 328.06",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.28 328.06 52.28 356.75 150.78 413.62 150.78 384.92 52.28 328.06",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "150.78 393.11 119.67 375.81 150.78 394.57 150.78 393.11"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    points: "52.28 342.28 62.65 348.87 52.28 343.49 52.28 342.28"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    points: "52.28 347.99 104.11 378.8 52.28 349.75 52.28 347.99"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "150.78 398.81 98.94 369.82 150.78 400.69 150.78 398.81"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "150.78 413.62 347.78 299.89 347.78 271.19 150.78 384.92 150.78 413.62",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.78 413.62 347.78 299.89 347.78 271.19 150.78 384.92 150.78 413.62",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.78 393.11 161.16 387.77 150.78 394.57 150.78 393.11",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.78 398.81 202.91 369.68 150.78 400.69 150.78 398.81",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.78 285.31 311.49 306.97 347.78 286.72 347.78 285.31",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.79 291.33 327.05 303.97 347.78 292.67 347.79 291.33",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.62 277.12 235.55 335.98 266.65 318.03 164.72 259.16 133.62 277.12",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.65 318.03 266.65 348.84 235.55 366.79 235.55 335.98 266.65 318.03",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.55 366.79 233.73 365.74 235.55 364.68 235.55 366.79",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.62 277.12 133.62 281.1 137.06 279.11 133.62 277.12",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "233.73 365.72 233.73 337.04 235.55 335.98 235.55 364.67 233.73 365.72"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "233.73 337.04 135.24 280.16 137.06 279.11 235.55 335.98 233.73 337.04"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "136.97 275.19 238.91 334.04 241.5 332.55 139.56 273.7 136.97 275.19",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.75 262.62 260.7 321.47 263.29 319.98 161.35 261.13 158.75 262.62",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.91 334.04 238.91 364.85 241.5 363.35 241.5 332.55 238.91 334.04",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.7 321.47 260.7 352.27 263.3 350.77 263.29 319.98 260.7 321.47",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--money--inject-159"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-159",
    points: "333.08 267.35 140.24 378.69 140.24 407.54 52.28 356.75 52.28 328.06 245.26 216.64 333.08 267.35",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.09 295.55 31.09 324.25 129.59 381.12 129.59 352.42 31.09 295.55",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.09 295.55 31.09 324.25 129.59 381.12 129.59 352.42 31.09 295.55",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "129.59 360.61 98.48 343.31 129.59 362.06 129.59 360.61"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "31.09 309.78 41.46 316.37 31.09 310.99 31.09 309.78"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "31.09 315.49 82.92 346.29 31.09 317.25 31.09 315.49"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "129.59 366.31 77.75 337.32 129.59 368.19 129.59 366.31"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "129.59 381.12 326.59 267.39 326.59 238.69 129.59 352.42 129.59 381.12",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.59 381.12 326.59 267.39 326.59 238.69 129.59 352.42 129.59 381.12",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "129.59 360.61 139.97 355.27 129.59 362.06 129.59 360.61",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.59 366.31 181.72 337.18 129.59 368.19 129.59 366.31",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.59 252.81 290.3 274.46 326.59 254.22 326.59 252.81",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.59 258.83 305.85 271.47 326.59 260.17 326.59 258.83",
    style: {
      fill: "#76ABAE"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "31.09 295.55 228.09 181.82 326.59 238.69 129.59 352.42 31.09 295.55",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.09 295.55 228.09 181.82 326.59 238.69 129.59 352.42 31.09 295.55",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.09,187.8,41.45,295.55l88.13,50.89L316.23,238.69ZM129.58,343.44,46.64,295.55,228.09,190.8l83,47.89Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.11,288.84c-8.82-5.09-13.68-12-13.68-19.59,0-8.23,5.93-16.38,16.27-22.34,20.25-11.7,52.05-12.37,70.87-1.5,8.82,5.09,13.68,12,13.68,19.59,0,8.23-5.93,16.38-16.27,22.34h0c-10.62,6.13-24.4,9.23-37.82,9.23C163,296.57,151.07,294,142.11,288.84Zm3.47-40.41c-9.77,5.65-15.38,13.23-15.38,20.82,0,6.88,4.54,13.3,12.79,18.06,18.34,10.59,49.34,9.92,69.11-1.49h0c9.77-5.65,15.38-13.23,15.38-20.82,0-6.88-4.54-13.3-12.79-18.06-8.72-5-20.3-7.53-32.17-7.53C169.41,239.41,156,242.45,145.58,248.43Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.3,283.31c-6.76-3.9-10.49-8.89-10.49-14.06,0-5.89,4.77-12,13.08-16.82,9.25-5.34,21.87-8.4,34.63-8.4,11.54,0,22.15,2.45,29.86,6.9,6.76,3.91,10.48,8.9,10.48,14.07,0,5.89-4.76,12-13.07,16.82-9.25,5.34-21.87,8.4-34.62,8.4C163.61,290.22,153,287.76,145.3,283.31Z",
    style: {
      fill: "#76ABAE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134.34,329.66a10.56,10.56,0,0,0-9.5,0l-5.62,3.24-54-31,6.51-3.75a2.31,2.31,0,0,0,0-4.46L65.21,290l59.3-34.43-1.16,2.53a23.25,23.25,0,0,0-2.19,9.71c0,9.65,9.67,19.55,19.26,25.08,8.55,4.94,23.51,9.92,37.67,9.92a90.79,90.79,0,0,0,11.68-.75l4.34-.55L140,332.92Z",
    style: {
      fill: "#76ABAE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.18,309.08c-2.25-1.3-3.49-3.11-3.49-5.1,0-2.14,1.49-4.23,4.08-5.73,4.85-2.8,12.47-2.95,17-.34,2.25,1.29,3.48,3.1,3.48,5.09,0,2.15-1.48,4.23-4.08,5.73a18.45,18.45,0,0,1-9,2.21A16.23,16.23,0,0,1,108.18,309.08Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M234.17,276.15a34,34,0,0,0,2.27-11.84c0-8-6.32-15.75-18.79-22.95-10-5.77-25.3-9.64-38.14-9.64a92.54,92.54,0,0,0-11.69.74l-4.38.57,54.14-31.16,5.62,3.25a10.68,10.68,0,0,0,9.48,0l5.62-3.25,53.92,30.71-6.51,3.77a2.31,2.31,0,0,0,0,4.46l6.51,3.75L233,278.65Z",
    style: {
      fill: "#76ABAE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.15,237.79c-2.25-1.3-3.49-3.11-3.49-5.1,0-2.15,1.49-4.23,4.09-5.73,4.84-2.8,12.46-3,17-.35,2.25,1.3,3.49,3.11,3.49,5.1,0,2.15-1.49,4.23-4.08,5.73h0a18.49,18.49,0,0,1-9,2.21A16.29,16.29,0,0,1,232.15,237.79Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.87,246.61l-78,49.53c27.46,17.58,58.41,35.7,92.34,54.27l84.16-46.93Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.9,246.6c-27,14.75-55.75,25-85.33,33.62a553,553,0,0,0,99,67c21.4-8.52,57.7-28.5,73.29-37.22,11.06-6.31,11.49-6.53,11.49-6.53Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.9,246.6c-27,14.75-55.75,25-85.33,33.62a553,553,0,0,0,99,67c21.4-8.52,57.7-28.5,73.29-37.22,11.06-6.31,11.49-6.53,11.49-6.53Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.65,298.93c-25.36,14.7-50.54,29.23-77.69,40.42C99.69,323.8,71.17,304,45.81,284.3a369.27,369.27,0,0,0,77.81-33.13l-2.55-1.56C95.77,264.17,69.28,275.83,40.93,283c25.78,21.78,57,42.38,87.9,58.92,28-11.57,54.18-26.33,80.39-41.49Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.23,292.43c-18.25,4.26-36,3-49.51-3.67-8-3.95-13.55-8.52-15.34-17.14-1.14-5.48,2.38-11.22,4.33-14.15l-1.53-.89c-2.37,3.68-5.66,9.91-4.54,15.34,1.88,9.13,6.24,13.42,15.38,18.3A60.9,60.9,0,0,0,172.83,297c12.54,0,19.07-1.54,24.56-3.3Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.74,259.8c-2.17,2.22-4.38,6.9-3.91,9.85,1.09,7,5.26,10.25,12.31,14.11,7.82,4.27,16,6.46,28.63,6.63A83.64,83.64,0,0,0,189.23,289Z",
    style: {
      fill: "#76ABAE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.46,302.66a57,57,0,0,1-11.86.3,80.29,80.29,0,0,1-34.09-9.84c-11.57-6.41-20-13-20.73-25.11a22.63,22.63,0,0,1,1.34-9.45c.83-2,1.29-2.87,1.29-2.87-19.86,11.54-36.95,20.56-59,27.37a68.35,68.35,0,0,1,6,4c1.18.88,2.34,1.7,2.06,3-.23,1-1.69,1.53-2.91,2-1.81.7-3.11,1.14-5.41,1.83,17,12,32.38,25.2,53.22,35.49a23.34,23.34,0,0,1,5.8-2.25,17,17,0,0,1,10,.78,24.67,24.67,0,0,1,5.67,3.18c19.14-7.92,36.65-18.67,54.18-29.56A42.11,42.11,0,0,1,188.46,302.66Z",
    style: {
      fill: "#76ABAE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.28,298a26,26,0,0,0-16.2-.59c-2.76.76-4.1,1.81-4.41,4.42s1.29,3.61,3.44,5a18.7,18.7,0,0,0,7.83,2.53,18.36,18.36,0,0,0,8.66-1.12c2.48-1.11,4.13-2.54,4.22-5.19S127.8,299,125.28,298Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "112.43 244.62 214.36 303.48 245.46 285.53 143.53 226.66 112.43 244.62",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.46 285.53 245.46 316.33 214.36 334.29 214.36 303.48 245.46 285.53",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.36 334.29 212.54 333.23 214.36 332.18 214.36 334.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.43 244.62 112.43 248.46 115.87 246.61 112.43 244.62",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "212.54 333.22 212.54 304.54 214.36 303.48 214.36 332.17 212.54 333.22"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "212.54 304.54 113.98 247.62 115.87 246.61 214.36 303.48 212.54 304.54"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "115.78 242.69 217.72 301.54 220.31 300.04 118.37 241.2 115.78 242.69",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.56 230.12 239.51 288.97 242.09 287.47 140.16 228.63 137.56 230.12",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.72 301.54 217.72 332.35 220.31 330.85 220.31 300.04 217.72 301.54",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.51 288.97 239.51 319.77 242.1 318.27 242.09 287.47 239.51 288.97",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.1,338.88c-2.64,2.28-7.3,10.32-7.3,10.32a6.5,6.5,0,0,0,1.31,5.87l9.32-10.59Z",
    style: {
      fill: "#263238"
    }
  }), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "168.11 355.07 180.71 360.99 188.87 354.28 177.43 344.48 168.11 355.07"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.89,326.69c.26-.46.54-1,.83-1.44a1.59,1.59,0,0,1,2.18-.59c-.17.38-.45.88-.51,1.08.08.39.12,1.13,1.78,3a11.46,11.46,0,0,0,2.48,2.13c1,.59,1.84,1.34,2.81,1.93a2.29,2.29,0,0,1,.73.57,2.39,2.39,0,0,1,.19,1.86c-.21,1.22-.42,2.43-.62,3.65-.11.59-.21,1.19-.31,1.78a4.84,4.84,0,0,0-.25,1.7.42.42,0,0,0,.27-.17,24.16,24.16,0,0,1,6.52-5.43,1.08,1.08,0,0,1,.48-.18.47.47,0,0,1,.51.48c0,.24-3.33,6.69-5.37,12.25a57.88,57.88,0,0,0-3.3,12.34c-1.11,8.88.16,17.23.4,21.6.32,5.85-5.44,6.65-13.31-1.93-3.9-4.26-8-12.4-7.65-16.85s3.7-10,3.78-13.4-2.5-9-1.43-12.16l.06-.17a16.23,16.23,0,0,1,2-3.73,28.24,28.24,0,0,1,3.53-3.72l.42-.42,1.91-1.9a12,12,0,0,0,1.67-2A3.31,3.31,0,0,0,183.89,326.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.31,278.33c-3.56-5.38-6.1-7.52-22.09-19.58a387,387,0,0,0-32.45-21.46l-19.61,21,17.18,17.15,26.32,17.29a35.91,35.91,0,0,0-7.21,10.55c-1,2.13-9.92,25.91-9.92,25.91l13.53,16.49s20.46-30.19,29.45-44.9C240,286.91,237.64,280.34,236.31,278.33Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.85,228.09c4.28,4.2,9.06,7.52,20.56,16.8,10.34,8.35,27.1,22.37,30.14,30.72,2.72,7.45.87,14.17-5.08,25S201,348,201,348l-13.6-17s7.78-24.77,11.65-31.38c3-5.18,5.44-6.64,5.44-6.64l-40.38-21.91-6.76-24C161.32,234.87,175.21,229.86,187.85,228.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,348l-13.6-17s7.78-24.77,11.65-31.38a29,29,0,0,1,3.46-4.84c3.22,4.94,5.11,7.69,6.17,19.47.48,5.33.88,13.76,1.17,21.38C204.85,342.75,201,348,201,348Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.65,244.89c-.27,9.58-1.2,16.8-1.2,16.8l21.33,29.25-36.63-19.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.94,252.14c5,3.61,16.09,15.06,18.57,17.77a63.43,63.43,0,0,1,7.18,8.92,17.24,17.24,0,0,1,1.94,3.89,6.25,6.25,0,0,1,.31,2,12,12,0,0,1-.32,2.09,47,47,0,0,1-3.12,8.44c-1.25,2.78-2.65,5.5-4.07,8.21q-4.31,8.11-8.89,16.14a163.1,163.1,0,0,0,10.24-15.39q2.35-4,4.39-8.18a44.86,44.86,0,0,0,3.32-8.8,14.88,14.88,0,0,0,.34-2.46,7.91,7.91,0,0,0-.42-2.57,17.08,17.08,0,0,0-2.23-4.31,63.45,63.45,0,0,0-7.43-8.91C218.33,264.31,208.31,255.15,202.94,252.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.61,425.69c-.76-1.1-6.6-8.35-7.52-9.71-4.24-6.23-6.87-16.67-9.06-23.17-1.2-3.55-1.74-12.9-2.82-22.75h0s-5.14-59.27-7.08-68.3-29.2-38.71-29.2-38.71,5.79-11.12,5.23-37.87c-14.31,8.7-32.3,8.77-52.24,4.23-2.47,9.83-7.69,19.85-5.53,30.47S133.5,280.15,146.61,290c10.85,8.16,25.43,19.42,28.47,21.76,2.67,2.05,4.19,4.38,3.84,10.86-.38,6.69-1.85,17.7,7.19,40,3,8.7,5.64,22.29,6.42,27l-.28,2.95a6.45,6.45,0,0,0,1.1,4.31c.89,1.4,1.84,2.72,2.86,4,2.72,3.49,7.76,11.25,11.19,16.79,4.94,8,11.95,10.43,18.54,11.05S230.28,426.67,229.61,425.69Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,408.71c-.74,3.41.55,12.63.55,12.63a6.72,6.72,0,0,0,4.9,3.83l1-14.08Z",
    style: {
      fill: "#263238"
    }
  }), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "196.42 425.17 213.13 421.34 213.36 411.82 197.4 411.09 196.42 425.17"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M191.31,393.07c-.08-.52-.19-1.11-.23-1.64a1.64,1.64,0,0,1,1.45-1.81c.1.41.19,1,.27,1.17a4.74,4.74,0,0,0,3.42,1.92,28.82,28.82,0,0,0,3.72.26,57,57,0,0,0,5.91-.19,2.74,2.74,0,0,1,1,0,2.48,2.48,0,0,1,1.36,1.36,40.08,40.08,0,0,0,3.35,4.79.34.34,0,0,0,.12-.3,29.21,29.21,0,0,1,.87-6.78c.21-.8.75-1.28.8-1.1.26,1,.95,4.22,1.23,5a52.87,52.87,0,0,0,3.83,9.35,72.75,72.75,0,0,0,7.34,12c7.11,9.39,10.9,11.46,13.22,14.68,3.5,4.87-1,8.85-13.78,8.45-8.41-.26-17-6.14-19.64-9.86s-3.37-10.18-5.49-12.9-7.93-5.58-9.08-8.73l-.06-.17a15.72,15.72,0,0,1-.71-4.19,27.27,27.27,0,0,1,.56-5.1c0-.2.05-.39.08-.59.12-.89.24-1.78.37-2.67a11.15,11.15,0,0,0,.14-2.58C191.34,393.29,191.33,393.18,191.31,393.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.42,227.05c-2,4-5.66,13.44-6,21.81s-.85,17.93,14.31,31.95c12.59,11.66,45.65,31.82,46.85,35s1.46,27.94,4,35.3c4.76,13.66,11,31.22,11,31.22,8.14,2.51,15.91,1.65,21-2,0,0-2.94-33.22-4.06-47.24-1.9-24-1.87-31.42-6.07-37.64s-5.69-8.18-5.69-8.18L176,262.22s2.7-6,4.66-17.33c1.32-7.58-.22-17.86-.22-17.86S145.22,236.2,120.42,227.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.78,257.35l-.14-.44c-4.16-7.39-2.43-14.11-.16-22.91.38-1.48.77-3,1.15-4.62l.94.23c-.39,1.6-.78,3.15-1.16,4.63-2.17,8.41-3.81,14.88-.1,21.84,6.75-3,6.06-13.76,5.62-20.29-.07-1.07-.14-2-.16-2.85l1,0c0,.8.09,1.75.16,2.82.45,6.77,1.19,17.91-6.1,21.22a27.08,27.08,0,0,0,2.43,3.4c4.89,5.84,17.36,18.33,28.37,29.34,8.69,8.71,16.2,16.22,17.83,18.34,2.06,2.68,2.83,10.43,3.81,20.23.8,8,1.71,17.15,3.53,25.3a130.56,130.56,0,0,0,11.11,29.85l-1.15-.13a131.5,131.5,0,0,1-10.9-29.51c-1.84-8.2-2.75-17.34-3.55-25.41-.92-9.27-1.72-17.28-3.61-19.74-1.59-2.07-9.08-9.57-17.76-18.25-11-11-23.51-23.52-28.42-29.41a26.39,26.39,0,0,1-2.6-3.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.06,236.46a32.33,32.33,0,0,0-.16,9.27,46.42,46.42,0,0,0,2,9.09,49.38,49.38,0,0,0,3.74,8.52,41,41,0,0,0,5.34,7.57c-1.41-2.75-2.77-5.47-4-8.24s-2.32-5.58-3.25-8.45a77.53,77.53,0,0,1-2.35-8.73A74.67,74.67,0,0,1,148.06,236.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.93,236.4a30.22,30.22,0,0,0-2.32,7.52,50.2,50.2,0,0,0-.8,7.83,54.27,54.27,0,0,0,.42,7.86,31,31,0,0,0,1.82,7.65c-.19-2.62-.27-5.18-.32-7.76s-.07-5.14,0-7.71.17-5.12.35-7.68S145.56,239,145.93,236.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.34,281.94c2.92,4.41,6,8.71,8.91,13.09,1.43,2.2,2.83,4.41,4,6.71a26.84,26.84,0,0,1,2.66,7.14c.43,2.53.84,5.18,1.22,7.77l1.18,7.83q1.15,7.83,2.61,15.64-.25-8-1.06-15.84c-.55-5.27-1.15-10.49-2.08-15.77a26,26,0,0,0-3-7.6,60.56,60.56,0,0,0-4.4-6.71C189.27,289.93,185.82,285.92,182.34,281.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.29,377c-3.21,3-17,4.73-21.86,2.28l1.64,7s3.32,1.78,11.56,1.29,9.29-3.72,9.29-3.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.55,221.54c4.5,2.77,12.34,6.07,24.88,6.43s25.27-4.6,29.07-8.08l1,6.57s-10.58,8.56-30.06,8.34-26.24-7.11-26.24-7.11Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.91,124.36a5.93,5.93,0,0,0-3.44.9,38.43,38.43,0,0,0-4.48,3.68c-2.3,1.84-6,4.85-9,5.25-.61.08-1.89.06-1.2-.83a25.55,25.55,0,0,0,2.56-3.57,5.28,5.28,0,0,0,.49-4.24,1.84,1.84,0,0,0-.8-1c-.57-.28-.86,0-1.2.38a10.62,10.62,0,0,1-1.18,1L233.2,128c-4.8,4.1-9.5,8.73-11.69,14.8-.32.89-2,7.67-3.12,11.53-.87,3.5-7.23,25.54-7.23,25.54l-18.31-11.78a57,57,0,0,0-16.31-7.79c-2.93-.82-8.66-1.88-8.66-1.88l13,30.74s21.32,10.53,24.67,12.14c5,2.4,14.44,6.77,18.93.39,5.51-7.81,5.85-19.44,6.85-28,1.12-9.67,1.17-14.22,2.26-17.28s3.65-3.72,5.38-4.62a28.81,28.81,0,0,0,6.65-4.44,26.73,26.73,0,0,0,4.82-5.09,8.26,8.26,0,0,0,1.68-3,24.34,24.34,0,0,1,0-2.83c.26-1.08,1-2,1.17-3.11a10.47,10.47,0,0,0-.29-2.6c-.19-1.37.51-2.31,1.3-3.35a4.14,4.14,0,0,0,.94-1.63C255.44,124.78,254.72,124.43,253.91,124.36Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.82,155.35c9.82,1,18.42,7.86,23.62,11.45,12.85,8.86,17,10.83,17,10.83l2-2.17s1.23,5,7.37,8.19S229.93,186,229.93,186a45.86,45.86,0,0,1-2.59,11.26c-2.06,5.16-4,7.77-8.21,8.3s-13-3.18-21.43-7.55-18.92-9-18.92-9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.44,177.63c-1.83,4.09-3.66,11.53-2.15,17.26-5-6.9.07-18.41.07-18.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.6,190.27c-6.1-7-9.75-21.11-9.75-21.11l-2.75-4.3.68,24.15s10.48,4.6,18.92,9a94.19,94.19,0,0,0,15.77,6.76C213.1,204.57,196.62,197.15,190.6,190.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.29,188a16.34,16.34,0,0,0,5.86,3.51c5.52,1.55,7.31.29,7.6-1s-.94-1.93.24-3.74,1.15-2.47.8-3.87,1.66-4.41-.9-5.17l-.5,2.36A19.49,19.49,0,0,1,220,177.81c-5.55-2.9-6.43-6.41-6.43-6.41L214,170a1.78,1.78,0,0,0-1.9,1.19c-.46,1.35,0,3.2-1.14,4.17s-1,2.29-.51,3.76c.71,2.24,3.24,5.81,6.83,8.91",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.12,137.36c-.63,3.59-3.34,8-5.11,9.47,0,0,3.16-.91,4.45-3.39A7.52,7.52,0,0,0,234.12,137.36Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.47,209.76a42.23,42.23,0,0,0-2.5-14c-2.4-7.3-1.61-15.86-1.86-22.07-.37-9.2,1-14.07,3.9-15.81,0,0,6.57-2.42,8.83-2.73,3.17-.44,8.3-1.09,14.71-1.71,11-1,23.27,1.94,23.27,1.94,5.67,4.54,9.53,7.52,16.47,17.38,4.16,5.93,6.76,16.18-1.7,23.87.16,1.88,1.17,5.79.81,18.57,2.1,5.34,3.91,6.87,2.45,12.92,0,0-9.72,10.94-32,10.53-25.09-.46-32.92-9.68-35.44-11.57C117.17,224.51,123.51,214.78,123.47,209.76Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.42,227.05a2.44,2.44,0,0,1-.92-1.43,5.61,5.61,0,0,1-.11-1.73,18.33,18.33,0,0,1,.67-3.39c.65-2.21,1.47-4.34,2.11-6.51a21.23,21.23,0,0,0,.73-3.24,21.74,21.74,0,0,0,0-3.32,40.81,40.81,0,0,0-1-6.66q-.39-1.64-.87-3.27c-.32-1.07-.69-2.16-1-3.29a38,38,0,0,1-1-6.84c-.13-2.3-.12-4.59-.08-6.87s.17-4.56.22-6.84c.38,4.55.26,9.13.73,13.64a43.52,43.52,0,0,0,1.17,6.64c.3,1.06.66,2.14,1,3.24s.64,2.22.91,3.33a38.62,38.62,0,0,1,1,6.86,22.82,22.82,0,0,1,0,3.5,18.75,18.75,0,0,1-.89,3.39c-.76,2.18-1.67,4.27-2.41,6.4a17.93,17.93,0,0,0-.9,3.26A3.4,3.4,0,0,0,120.42,227.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,198.57c1.28-10.87-1-15.53-3.38-20.47-.38-.77-.76-1.56-1.14-2.39l-1.08.49c.38.84.77,1.64,1.15,2.42,2.42,5,4.51,9.29,3.27,19.81-1,8.73-.5,25.31.18,38.54l1.17-.32C171.45,223.51,170.94,207.17,172,198.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.41,197.75s-6.76,7.56-16.35,6a16.33,16.33,0,0,1-9.57-5,.66.66,0,0,0-1.05.79c1.67,2.91,4.92,6.14,11.21,6.89C160.23,207.87,164.41,197.75,164.41,197.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,91.89c4,1.1,5.76,2.18,8.48-1.75,3.33-3.69,9.23-3.34,12.68,0,1.18,1.1,2.43,2.58,4,2.32.87-.14,1.9-.87,3.45-1.28A6.17,6.17,0,0,1,176,93.69c.69,1.25.51,2.8.57,4.23a3.77,3.77,0,0,0,2,3.38,2.25,2.25,0,0,0,3-1.75c1.53.94,1.58,3.46.44,4.89a6.35,6.35,0,0,1-4.78,2c3.27,0,6.62,3.25,5.55,6.82-.48,1.57-1.84,2.81-1.94,4.46-.14,2,1.66,3.61,2.45,5.49a6,6,0,0,1-1.92,7c-1.71,1.19-4,1.3-5.62,2.57s-2.48,3.84-3.79,5.74c-6.51,8.86-12.94-1.41-20,3.41a17.3,17.3,0,0,0-2.51,2.48c-.34.37-.67.73-1,1.07a3.8,3.8,0,0,0-.88.91,2.94,2.94,0,0,1-2,1.53,8.56,8.56,0,0,1-2.53.12c-2.72-.15-5.61-.47-7.72-2.29a20.29,20.29,0,0,1-1.88-2,8,8,0,0,0-4.33-2.88c-2-.35-4.08.53-5.91-.3a6.55,6.55,0,0,1-2.85-3.51,13,13,0,0,0-2.27-4.05,4.82,4.82,0,0,0-5-1.13,7.88,7.88,0,0,1,2.26-4.94c.88-.87,1.93-1.49,2.88-2.26a5,5,0,0,0,.88-.84,4.74,4.74,0,0,0,.67-1.15,7.65,7.65,0,0,0,.57-2.68c0-.34,0-.68,0-1-.08-1.87-.51-3.72-.53-5.59,0-3,1.16-6.19,3.55-7.88,1.08-.77,2.35-1.2,3.5-1.87a5.71,5.71,0,0,0,2-1.86c.21-.34.38-.71.6-1a3.45,3.45,0,0,0,.42-1,14,14,0,0,1,1.47-4.24C133.36,92.11,137.53,91.08,141,91.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.42,104c4,3.58,6.47,7.66,5.8,13.56-.21,1.87,1.32,4.86,1.51,7.24,1,13.34-3.4,19.59-7.22,21.62-2.27,1.21-6.34,1.26-6.34,1.26l.6,6.62s9.49,12.84,6.5,24.82C149.6,168.43,140.37,155,140.37,155L139,138.12s-1.71,2.32-5.76.27c-3.29-1.67-5.52-7.2-3.15-10.48s6-2.91,7.51.29c1.37,2.89,4.34,2.58,3.86-2.53s-2.26-13.28,3.74-18.11C156.81,106.36,157.66,115.58,167.42,104Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.1,151.71l.13,1.57s8.15,12.88,28,25.82c-8-.47-21.28-5-21.64-6.07a34.21,34.21,0,0,1-.36-5.51l-14.43-12.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.27,179.1s5-6.48,5-11.32c0-1.57-5-4.55-5-4.55l-.34-7.81-6.4-3.71.24,2.74A41.52,41.52,0,0,1,168.27,179.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.91,134.05l6.26,1.58a3.09,3.09,0,0,1-3.81,2.39A3.38,3.38,0,0,1,155.91,134.05Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.97 118.53 161.07 131.47 167.42 129.15 158.97 118.53",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.21,122.56a2.08,2.08,0,1,1-2.08-2.08A2.08,2.08,0,0,1,154.21,122.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.19,121.3a2.08,2.08,0,1,1-4.12-.56,2.08,2.08,0,0,1,4.12.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.49,116.22l-4.89-2.17a2.67,2.67,0,0,1,4.89,2.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.34,118.43l4.6-2.73a2.67,2.67,0,1,0-4.6,2.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.17,147.66c-4.71.1-13.37.11-18.77-6.17,0,0,2,4.6,5.4,6.28,4.74,2.37,13.56,2,13.56,2Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.78,138a2.9,2.9,0,0,0-3.13-2.6,2.67,2.67,0,0,0-.69.16,3.34,3.34,0,0,0,2.4,2.42A3,3,0,0,0,159.78,138Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.56,161.67c-4.36,2.92-6.44,5-12.79,11.33l-8.34,8.83C93.32,175.4,91,161.73,90.59,159c-.73-4-1.63-10.89-1.85-11.8-1.51-6.27-5.69-11.39-10-16l-2.25-2.34a11.56,11.56,0,0,1-1.06-1.16c-.29-.4-.56-.72-1.15-.5a1.78,1.78,0,0,0-.91.92,5.29,5.29,0,0,0,0,4.27,25.29,25.29,0,0,0,2.16,3.82c.58,1-.69.84-1.29.69-2.91-.71-6.26-4.11-8.34-6.19a39.78,39.78,0,0,0-4.06-4.15,6,6,0,0,0-3.32-1.26c-.81,0-1.57.24-1.49,1.26a4.21,4.21,0,0,0,.76,1.72c.68,1.12,1.27,2.13.94,3.48a10.35,10.35,0,0,0-.58,2.55c0,1.11.68,2.11.82,3.22a23.62,23.62,0,0,1-.28,2.82,8.15,8.15,0,0,0,1.35,3.12,27,27,0,0,0,4.23,5.58,29.07,29.07,0,0,0,6.14,5.14c1.61,1.08,4.1,2,4.85,5.17s.29,7.69.36,17.43c.06,8.65-.13,21.33,4.5,29.7,4.81,6.13,14,1.3,18.89-1.35,3.26-1.78,20-11.88,20-11.88l4-34.84A30,30,0,0,0,115.56,161.67Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.15,157.44c-9.75,1.5-14.07,7.38-18.55,11.75C96.86,177.72,93,181.55,93,181.55l-2.13-1.88s-1,5.08-7,8.55-8.53,3.53-8.53,3.53.59,5.36,1.69,10.41c1.19,5.43,4.41,7.56,8.62,7.88s12.82-3.83,21-8.62S121.06,193,121.06,193C127.62,187.09,130.86,162.27,124.15,157.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.71,180.39c2.18,4,1.92,11.43,1.28,15.06,2.28-3.95,2.93-11,.25-17.11l-1.53,1.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.83,168.49c-.09.6-2.56,16-15.06,26.75-6.94,5.95-21.13,13.54-21.49,13.72h0a54,54,0,0,0,5.35-2.2l.06,0c.6-.29,1.22-.58,1.84-.89l.1,0c1.25-.62,2.54-1.29,3.83-2l.41-.23,1.48-.82.49-.27,1.85-1.07,4.37-2.55,3.78-2.22,2.11-1.24,1.73-1,1.07-.64.69-.4.62-.37C125.28,189.19,128.12,177.58,127.83,168.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.09,191.79a20.45,20.45,0,0,1-7.28,2.77c-5.65,1-7.31-.45-7.47-1.72s1.13-1.83.14-3.74-.9-2.57-.41-3.93-1-4.55,1.59-5.06l0,2.4a19.77,19.77,0,0,0,10.6-1.29c5.81-2.33,7-5.73,7-5.73L93.1,174a1.74,1.74,0,0,1,1.73,1.37c.32,1.39-.45,2.49.62,3.52a4.48,4.48,0,0,1,.42,4.36C94,187.67,93,189.06,89.09,191.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.81,140.4c.23,3.63,2.44,8.33,4,10,0,0-3-1.25-4.07-3.85A7.51,7.51,0,0,1,76.81,140.4Z",
    style: {
      fill: "#874c4c"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMutualfunds);
export default __webpack_public_path__ + "static/media/mutualfunds.f88540dc15e6834709e43487410bceef.svg";
export { ForwardRef as ReactComponent };